import { useState, useEffect, useCallback, useRef } from "react";

// GOREV296: sade panel. Ana ekran "Bugün": 1) sana düşen iş 2) kanallar tek bakışta 3) büyüme 4) sorunlar.
// Sade Türkçe; kod adı / hata kodu / görev numarası ana ekranda yok (metinler sunucuda panel_home.py'de hazırlanır).
// Teknik ayrıntı yalnız Sistem sekmesinde. Giriş: oturum çerezi (panel_auth.py). Önceki sürüm: App.js.bak_20261005_gorev296

const API = "";
const COL = { green:"#34d399", yellow:"#fbbf24", red:"#f87171" };

function needLogin() { window.dispatchEvent(new Event("cos-login")); }

function useJSON(url, {refresh=0}={}) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(()=>{
    if(!url) return;
    let alive = true;
    fetch(API+url,{credentials:"same-origin"}).then(r=>{ if(r.status===401){ needLogin(); throw new Error("giriş gerekli"); } return r.json(); })
      .then(d=>{ if(alive){ setData(d); setErr(null);} })
      .catch(e=>{ if(alive) setErr(String(e)); });
    let t = refresh ? setInterval(()=>setTick(x=>x+1), refresh) : null;
    return ()=>{ alive=false; if(t) clearInterval(t); };
  // eslint-disable-next-line
  },[url, tick]);
  const reload = useCallback(()=>setTick(x=>x+1),[]);
  return [data, err, reload];
}

async function postJSON(url, body) {
  const r = await fetch(API+url,{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
  if(r.status===401){ needLogin(); return {ok:false,error:"giriş gerekli"}; }
  return r.json();
}

const C = { bg:"#0a0a0f", card:"rgba(255,255,255,0.05)", line:"rgba(255,255,255,0.08)", text:"#fff", dim:"rgba(255,255,255,0.55)",
  faint:"rgba(255,255,255,0.35)", green:"#34d399", yellow:"#fbbf24", red:"#f87171", gray:"#94a3b8", accent:"#7c6aff", blue:"#60a5fa" };

const S = {
  card: { background:C.card, borderRadius:14, padding:14, border:`1px solid ${C.line}`, marginBottom:12 },
  cardTitle: { fontSize:12, fontWeight:700, color:C.faint, letterSpacing:0.8, marginBottom:10, textTransform:"uppercase" },
  row: { display:"flex", alignItems:"center", gap:10, minHeight:44 },
  small: { fontSize:13, color:C.dim, lineHeight:1.4 },
  tiny: { fontSize:12, color:C.faint, lineHeight:1.4 },
};

const btn = (c=C.accent, extra={}) => ({ minHeight:44, padding:"0 16px", borderRadius:10, border:"none", background:c, color:"#fff",
  fontWeight:700, cursor:"pointer", fontSize:14, ...extra });

const ghost = (extra={}) => btn("rgba(255,255,255,0.08)", extra);

const inp = { minHeight:44, padding:"10px 12px", borderRadius:10, border:"1px solid rgba(255,255,255,0.15)", background:"#1a1a2e",
  color:"#fff", fontSize:16, width:"100%", boxSizing:"border-box", appearance:"none", WebkitAppearance:"none" };

const chip = (color) => ({ display:"inline-block", fontSize:12, padding:"3px 8px", borderRadius:6, background:color+"22", color,
  whiteSpace:"nowrap", fontWeight:600 });

const GLOBAL_CSS = `
*,*::before,*::after{box-sizing:border-box}
html,body{margin:0;background:${C.bg};overflow-x:hidden;-webkit-text-size-adjust:100%}
body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif}
button{font-family:inherit}
button:disabled{opacity:.5}
a{color:${C.blue}}
.wrap{word-break:break-word;overflow-wrap:anywhere}
select option{background:#1a1a2e;color:#fff}
`;

const TZ = "Europe/Istanbul";

const clean = s => String(s ?? "").replace(/\(?\bGOREV\s?\d+[\w.-]*\)?:?\s*/gi, "").replace(/\s{2,}/g, " ").trim();

const trTime = iso => { if(!iso) return ""; const d = new Date(iso); if(isNaN(d)) return "";
  return d.toLocaleString("tr-TR",{timeZone:TZ,day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}); };



const fmtNum = n => n==null ? "?" : Number(n).toLocaleString("tr-TR");

const hourTR = h => h==null ? "?" : `${String((Number(h)+3)%24).padStart(2,"0")}:00`;

async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; } catch(e) {
    try { const ta=document.createElement("textarea"); ta.value=text; ta.setAttribute("readonly","");
      ta.style.position="fixed"; ta.style.opacity="0"; document.body.appendChild(ta); ta.select();
      ta.setSelectionRange(0, text.length); const ok=document.execCommand("copy"); document.body.removeChild(ta); return ok;
    } catch(e2) { return false; }
  }
}

function Dot({color}) { return <span style={{width:10,height:10,borderRadius:5,background:color,display:"inline-block",flexShrink:0}}/>; }

function Bar({pct,color=C.accent,h=8}) {
  return <div style={{background:"rgba(255,255,255,0.08)",borderRadius:4,height:h,width:"100%"}}>
    <div style={{width:`${Math.max(0,Math.min(100,pct||0))}%`,height:"100%",background:color,borderRadius:4}}/></div>;
}

function Collapse({title, right, children, open:initial=false, color}) {
  const [open, setOpen] = useState(initial);
  return (
    <div style={{borderTop:`1px solid ${C.line}`}}>
      <button onClick={()=>setOpen(!open)} style={{...S.row,width:"100%",background:"none",border:"none",color:color||C.text,
        padding:"4px 0",fontSize:15,fontWeight:600,textAlign:"left",cursor:"pointer"}}>
        <span style={{flex:1,minWidth:0}} className="wrap">{title}</span>
        {right}
        <span style={{color:C.faint,fontSize:14}}>{open?"▲":"▼"}</span>
      </button>
      {open && <div style={{paddingBottom:10}}>{children}</div>}
    </div>
  );
}

function CopyBtn({text,label,onNotify}) {
  const [done,setDone] = useState(false);
  if(!text) return null;
  return <button style={ghost({flex:"1 1 30%",minWidth:0,padding:"0 8px",fontSize:13,color:done?C.green:"#fff"})}
    onClick={async()=>{ const ok=await copyText(text); setDone(ok); if(!ok) onNotify&&onNotify("Kopyalanamadı","error");
      setTimeout(()=>setDone(false),1800); }}>{done?"✓ Kopyalandı":`📋 ${label}`}</button>;
}

function Spark({values,finals,color=C.accent,h=36}) {
  const v = values.map(x=>x==null?null:x); const max = Math.max(1,...v.filter(x=>x!=null));
  return (
    <div style={{display:"flex",alignItems:"flex-end",gap:2,height:h,width:"100%"}}>
      {v.map((x,i)=>{ const prov = finals && finals[i]===false && x!=null;
        return <div key={i} title={x==null?"henüz işlenmedi":`${x}${prov?" (kesinleşmemiş)":""}`} style={{flex:1,height:x==null?2:Math.max(2,x/max*h),
          background:x==null?"rgba(255,255,255,0.12)":color,borderRadius:2,opacity:x==null?0.6:prov?0.4:1}}/>; })}
    </div>
  );
}

function Notify({msg,type,onClose}) {
  if(!msg) return null;
  const c = type==="error"?C.red:type==="warn"?C.yellow:C.green;
  return <div onClick={onClose} style={{position:"fixed",top:12,left:16,right:16,maxWidth:500,margin:"0 auto",background:"#1a1a2e",
    border:`1px solid ${c}`,borderRadius:12,padding:"12px 16px",color:c,fontWeight:700,fontSize:14,zIndex:9999,textAlign:"center"}}>{msg}</div>;
}

function Loading({text="Yükleniyor..."}) { return <div style={{...S.small,padding:"16px 0",textAlign:"center"}}>{text}</div>; }

function AiTable({ai}) {
  return (
    <div style={{paddingBottom:8}}>
      {(ai.rows||[]).map((r,i)=>(
        <div key={i} style={{padding:"8px 0",borderTop:`1px solid ${C.line}`}}>
          <div style={{display:"flex",justifyContent:"space-between",gap:8,fontSize:14}}>
            <span className="wrap">{r.model.split("/").pop()} <span style={{color:C.faint,fontSize:12}}>{r.org}</span></span>
            <span style={{color:r.exhausted_recent?C.red:(r.pct||0)>=(ai.warn_pct||80)?C.yellow:C.green,fontWeight:700}}>
              {r.exhausted_recent?"dolu":`%${r.pct}`}</span>
          </div>
          <div style={S.tiny}>üretim {fmtNum(r.prod)} · toplu {fmtNum(r.batch)}/{fmtNum(r.batch_cap)} · {r.calls} çağrı
            {r.denied?` · ${r.denied} toplu çağrı ertelendi`:""}{r.exhausted_recent?` · doldu ${trTime(r.exhausted)}`:""}</div>
        </div>))}
      <div style={{...S.tiny,marginTop:6}}>Günlük sayaç (gün 03:00'te sıfırlanır). Üretim 2/3 pay garantili; toplu işler 1/3 ile sınırlı. "Dolu" = son 24 saatte sağlayıcı limiti.</div>
    </div>
  );
}

function CommentItem({c,onNotify,onGone}) {
  const sg = c.suggestion;   // GOREV274: hassas yorum onerisi (kutu onceden dolu, duzenlenebilir)
  const [text,setText] = useState(sg && sg.action==="reply" ? (sg.reply||"") : "");
  const [busy,setBusy] = useState(false);
  async function send() {
    if(!text.trim()) return;
    setBusy(true);
    try {
      const d = await postJSON("/api/v2/comments/send",{comment_id:c.comment_id, channel:c.channel, parent_id:c.parent_id,
        video_id:c.video_id, text:text.trim()});
      if(d.ok){ onNotify("Yanıt gönderildi","success"); onGone(c); }
      else onNotify("Hata: "+String(d.error||"bilinmiyor").slice(0,120),"error");
    } catch(e) { onNotify("Hata: "+e.message,"error"); }
    setBusy(false);
  }
  async function dismiss() {
    const d = await postJSON("/api/v2/comments/done",{comment_id:c.comment_id,action:"dismissed"}).catch(()=>({}));
    if(d.ok) onGone(c); else onNotify("Gizlenemedi","error");
  }
  return (
    <div style={{borderTop:`1px solid ${C.line}`,padding:"10px 0"}}>
      <div style={{display:"flex",justifyContent:"space-between",gap:8}}>
        <span style={{fontSize:13,fontWeight:700,color:C.dim}}>{c.channel_name}</span>
        <a href={`https://youtu.be/${c.video_id}`} target="_blank" rel="noreferrer" style={{fontSize:13}}>videoyu aç</a>
      </div>
      {c.top_text && <div className="wrap" style={{...S.tiny,marginTop:4}}>↪ yanıtlanan: {c.top_text.slice(0,120)}</div>}
      <div className="wrap" style={{fontSize:15,marginTop:4}}><b>{c.author}</b>: {c.text}</div>
      {(c.replies||[]).length>0 && <div style={{...S.tiny,marginTop:4}}>{c.replies.map((r,i)=><div key={i} className="wrap">{r.own?"🟣 ":"• "}{r.author}: {String(r.text).slice(0,100)}</div>)}</div>}
      {sg && <div className="wrap" style={{...S.small,marginTop:6,color:sg.action==="reply"?C.dim:C.yellow}}>
        {sg.action==="reply" ? `✍️ Önerilen cevap${sg.model==="groq"?" (Groq önerisi)":""}` : "🤐 Öneri: Cevap verme"}
        {sg.reason ? ` — ${sg.reason}` : ""}{sg.reply_tr ? ` · TR: ${sg.reply_tr}` : ""}
        {(sg.warn||[]).map((w,i)=><div key={i} style={{color:C.red}}>⚠️ {w}</div>)}
        {sg.action!=="reply" && sg.reply && !text && <button style={ghost({marginTop:4})} onClick={()=>setText(sg.reply)}>
          Yine de cevaplayacaksan taslağı kutuya al</button>}</div>}
      <textarea value={text} onChange={e=>setText(e.target.value)} placeholder="Yanıtını yaz..." rows={sg?3:2}
        style={{...inp,marginTop:8,fontFamily:"inherit",resize:"vertical"}}/>
      <div style={{display:"flex",gap:8,marginTop:8}}>
        <button onClick={dismiss} style={ghost({flex:1})}>Cevaplamayacağım</button>
        <button onClick={send} disabled={busy||!text.trim()} style={btn(C.accent,{flex:1})}>{busy?"...":"Gönder"}</button>
      </div>
    </div>
  );
}

function Comments({onNotify}) {
  const [d] = useJSON("/api/v2/comments");
  const [gone,setGone] = useState({});
  if(!d) return null;
  const items = (d.items||[]).filter(c=>!gone[c.comment_id]);
  if(!items.length && !d.error) return null;
  return (
    <div style={S.card}>
      <div style={{...S.cardTitle,display:"flex",justifyContent:"space-between"}}><span>💬 Cevap bekleyen yorumlar</span><span>{items.length}</span></div>
      {d.error && <div style={{fontSize:13,color:C.yellow}}>{d.error}</div>}
      {items.map(c=><CommentItem key={c.comment_id} c={c} onNotify={onNotify} onGone={x=>setGone(g=>({...g,[x.comment_id]:true}))}/>)}
    </div>
  );
}

function PackageWatch({pw}) {
  if(!pw) return null;
  const bad = pw.alarms>0, d = s=>s?`${s.slice(8,10)}.${s.slice(5,7)}`:"?";
  return <div style={{...S.card,borderColor:(bad?C.red:C.green)+"55"}}>
    <div style={{...S.cardTitle,display:"flex",justifyContent:"space-between",gap:8}}>
      <span>📦 Paketler</span>
      <span style={{color:bad?C.red:C.green}}>Beklenen {pw.expected} / Gelen {pw.delivered}</span></div>
    <div style={S.tiny}>{d(pw.production_day)} üretimi (07:30'da Telegram'a) + bugünkü TikTok turu{pw.extra?` · ${pw.extra} plan dışı ek paket`:""}</div>
    {(pw.rows||[]).map((r,i)=>(
      <div key={i} style={{display:"flex",gap:8,padding:"6px 0",borderTop:`1px solid ${C.line}`}}>
        <span style={{marginTop:5}}><Dot color={r.alarm?C.red:r.delivered>=r.expected?C.green:C.yellow}/></span>
        <div style={{minWidth:0,flex:1}}>
          <div className="wrap" style={{display:"flex",justifyContent:"space-between",gap:6,fontSize:14}}>
            <span>{r.name} · <span style={S.tiny}>{r.platform}</span></span>
            {r.expected>0 ? <b>{r.delivered}/{r.expected}</b> : <span style={S.tiny}>+{r.delivered} plan dışı</span>}</div>
          {r.reason && <div className="wrap" style={S.small}>{r.stage?`${r.stage}: `:""}{r.reason}</div>}
        </div></div>))}
    {pw.today && <div className="wrap" style={{...S.small,marginTop:6}}>
      Bugünün planı ({d(pw.today.day)}, yarın 07:30'da gelir): hedef {pw.today.target}, beklenen {pw.today.expected}
      {pw.today.a_group?.length?` · elle: ${pw.today.a_group.join(", ")}`:""}</div>}
    {(pw.info||[]).length>0 && <Collapse title={`ℹ️ Beklenenin düşük olma nedenleri (${pw.info.length})`}>
      {pw.info.map((x,i)=><div key={i} className="wrap" style={S.small}>• {x}</div>)}</Collapse>}
    {pw.last_check?.ran_at && <div style={S.tiny}>Son 14:00 kontrolü: {pw.last_check.date} · {pw.last_check.ok?"çalıştı":"HATA"}{pw.last_check.alarms?` · ${pw.last_check.alarms} alarm`:""}</div>}
  </div>;
}

// GOREV273: ElevenLabs stogu - kanal basina stokta bekleyen video (4 Eki'den itibaren normal tempoyla akar)

function StockCard({st}) {
  if(!st || !(st.rows||[]).length) return null;
  return <div style={S.card}>
    <div style={{...S.cardTitle,display:"flex",justifyContent:"space-between",gap:8}}>
      <span>🗄️ Stok</span><span>{st.total} video</span></div>
    {st.rows.map(r=>(
      <div key={r.channel} className="wrap" style={{display:"flex",justifyContent:"space-between",gap:8,padding:"4px 0",
        borderTop:`1px solid ${C.line}`,fontSize:14}}>
        <span>{r.name}</span><b>stokta {r.stock} video</b></div>))}
    <div style={S.tiny}>Yüklenmez, Telegram'a gitmez; 4 Eki'den itibaren kanal temposuyla akar (history günde 1, masal haftada 2).</div>
  </div>;
}

// GOREV364: odak kanal hedef/gerceklesen kutusu (Cats 2/gun Shorts + haftada 1 uzun; Histories/Wealth 1/gun Shorts + haftada 3-4 uzun)
function FocusCard({fx}) {
  if(!fx || !(fx.rows||[]).length) return null;
  return <div style={S.card}>
    <div style={S.cardTitle}>🎯 Odak kanal hedefleri</div>
    {fx.rows.map(r=>(
      <div key={r.channel} className="wrap" style={{padding:"4px 0",borderTop:`1px solid ${C.line}`,fontSize:14}}>
        <b>{r.name}</b>
        <div>Shorts: bugün {r.shorts_today}/{r.shorts_target_per_day} · yarın {r.shorts_tomorrow}/{r.shorts_target_per_day}</div>
        <div>Uzun (7 gün): {r.long_this_week}/{(r.long_target_per_week||[0,0])[0]===(r.long_target_per_week||[0,0])[1]?(r.long_target_per_week||[0,0])[0]:`${(r.long_target_per_week||[0,0])[0]}–${(r.long_target_per_week||[0,0])[1]}`}</div>
      </div>))}
    {(fx.violations||[]).map((v,i)=>(<div key={i} style={{...S.small,color:C.yellow}}>⚠️ Odak ihlali: {v.why}</div>))}
    {fx.capacity && <div style={S.tiny}>{fx.capacity}</div>}
  </div>;
}

// GOREV364: ucretli AI butce kutusu (bugun / tavan / kalan bakiye / kalan gun / model dagilimi)
function AiBudgetCard({b}) {
  if(!b || !b.enabled || b.day_try===undefined) return null;
  const m = b.models_today||{}, sm = b.script_models_7d||{};
  return <div style={S.card}>
    <div style={S.cardTitle}>💳 Ücretli AI bütçesi</div>
    <div style={{fontSize:15}}>Bugün <b>{b.day_try.toFixed(1)}</b> / tavan <b>{b.daily_cap_try.toFixed(1)}</b> TL</div>
    <div style={S.small}>Kalan bakiye <b>{b.left_try}</b> TL · kalan <b>{b.days_left}</b> gün (toplam {b.spent_try.toFixed(0)}/{b.budget_try} TL)</div>
    <div style={S.tiny}>Bugünkü model dağılımı: {Object.keys(m).length?Object.entries(m).map(([k,v])=>`${k} ${v.try} TL (${v.calls})`).join(" · "):"harcama yok"}</div>
    <div style={S.tiny}>Son 7 gün senaryo modeli (video): {Object.keys(sm).length?Object.entries(sm).map(([k,v])=>`${k} ${v}`).join(" · "):"kayıt yok"}</div>
    <div style={S.tiny}>Pro yalnız odak kanal uzun video senaryosunda; diğer her iş ücretsiz kota → Flash.</div>
  </div>;
}

function Header({title,sub,right}) {
  return <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"4px 0 14px",gap:8}}>
    <div style={{minWidth:0}}><h2 style={{fontSize:24,fontWeight:800,margin:0}}>{title}</h2>
      {sub && <div style={S.tiny}>{sub}</div>}</div>{right}</div>;
}

function ChannelManage({c, onNotify, reload}) {
  const [topic,setTopic] = useState("");
  const [fmt,setFmt] = useState("shorts");
  const [limit,setLimit] = useState(c.daily_limit);
  const [busy,setBusy] = useState(false);
  async function call(url, body, okMsg) {
    setBusy(true);
    try { const d = await postJSON(url, body); if(d.ok){ onNotify(okMsg(d),"success"); reload&&reload(); } else onNotify("Hata: "+(d.error||"?"),"error"); }
    catch(e){ onNotify("Bağlantı hatası","error"); }
    setBusy(false);
  }
  async function uploadToken(file) {
    const fd = new FormData(); fd.append("channel_id", c.id); fd.append("token", file);
    const d = await (await fetch(API+"/api/channels/upload-token",{method:"POST",body:fd})).json().catch(()=>({}));
    if(d.ok){ onNotify("Token yüklendi","success"); reload&&reload(); } else onNotify("Token hatası: "+(d.error||"?"),"error");
  }
  return (
    <Collapse title="⚙️ Yönet (üret, konu, token, limit)">
      <div style={{display:"flex",gap:6,marginBottom:8}}>
        {["shorts","long"].map(f=><button key={f} onClick={()=>setFmt(f)} style={btn(fmt===f?C.accent:"rgba(255,255,255,0.08)",{flex:1})}>{f==="shorts"?"📱 Shorts":"🎬 Uzun"}</button>)}
      </div>
      <input style={{...inp,marginBottom:8}} placeholder="Konu (boş bırakılırsa sistem seçer)" value={topic} onChange={e=>setTopic(e.target.value)}/>
      <div style={{display:"flex",gap:6,marginBottom:8}}>
        <button disabled={busy} style={btn(C.green,{flex:1})} onClick={()=>call(topic.trim()?"/api/channels/produce-topic":"/api/channels/produce-now",
          topic.trim()?{channel_id:c.id,topic:topic.trim(),format:fmt}:{channel_id:c.id,format:fmt}, d=>topic.trim()?`'${topic}' üretiliyor`:`Üretim başladı (PID ${d.pid||"?"})`)}>🎬 Üret</button>
        <button disabled={busy||!topic.trim()} style={ghost({flex:1})} onClick={()=>call("/api/add-topic",{channel:c.id,topic:topic.trim()},()=>"Konu havuza eklendi")}>+ Havuza ekle</button>
      </div>
      <div style={{...S.row,marginBottom:8}}>
        <span style={{fontSize:13,whiteSpace:"nowrap"}}>Günlük limit</span>
        <input type="range" min="1" max="10" value={limit} onChange={e=>setLimit(e.target.value)} style={{flex:1,accentColor:C.accent}}/>
        <b style={{minWidth:18}}>{limit}</b>
        <button style={ghost()} onClick={()=>call("/api/channels/update",{channel_id:c.id,daily_limit:parseInt(limit)},()=>"Limit kaydedildi")}>Kaydet</button>
      </div>
      <div style={{...S.tiny,marginBottom:8}}>Not: gerçek tempo katman kuralından gelir (odak günde 1, diğer 2 günde 1); bu limit üst sınırdır.</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        <label style={{...ghost({flex:1}),display:"flex",alignItems:"center",justifyContent:"center"}}>📁 Token yükle
          <input type="file" accept=".json" style={{display:"none"}} onChange={e=>e.target.files[0]&&uploadToken(e.target.files[0])}/></label>
        <button style={btn(c.active?"#ef4444":C.green,{flex:1})} onClick={()=>{ if(window.confirm(`${c.name} ${c.active?"pasif":"aktif"} edilsin mi?`))
          call("/api/channels/update",{channel_id:c.id,active:!c.active},()=>c.active?"Pasif edildi":"Aktif edildi"); }}>{c.active?"⏸ Pasif et":"▶ Aktif et"}</button>
        {c.failed>0 && <button style={btn("#f59e0b",{flex:1})} onClick={()=>call("/api/channels/reset-failed",{channel_id:c.id},d=>`${d.pending} video kuyruğa alındı`)}>🔄 {c.failed} başarısızı yeniden dene</button>}
      </div>
    </Collapse>
  );
}

function Stat({v,l,color="#fff"}) {
  return <div style={{background:"rgba(255,255,255,0.04)",borderRadius:10,padding:"10px 8px",textAlign:"center"}}>
    <div style={{fontSize:22,fontWeight:800,color}}>{v}</div><div style={S.tiny}>{l}</div></div>;
}

function Hourly({channels}) {
  const [ch,setCh] = useState(channels[0]?.channel||"");
  const [showAll,setShowAll] = useState(false);
  const [d] = useJSON(ch?`/api/hourly-performance?channel=${encodeURIComponent(ch)}`:null);
  const rows = ((d?.byChannel||{})[ch]||[]);
  const vis = rows.filter(x=>showAll||x.sample_size>=5);
  const max = Math.max(100,...rows.map(x=>x.avg_view_pct));
  return (
    <div style={S.card}>
      <div style={S.cardTitle}>⏰ Yayın saatine göre izlenme oranı</div>
      <select value={ch} onChange={e=>setCh(e.target.value)} style={{...inp,marginBottom:8}}>
        {channels.map(c=><option key={c.channel} value={c.channel}>{c.name}</option>)}</select>
      {!d ? <Loading/> : rows.length===0 ? <div style={S.small}>Bu kanal için saat bazlı veri yok.</div> : <>
        {vis.length===0 && <div style={S.small}>5+ örnekli saat yok.</div>}
        {vis.map(x=>{ const few=x.sample_size<5, loop=x.avg_view_pct>100;
          return <div key={x.hour_utc} style={{padding:"6px 0",opacity:few?0.45:1}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:14}}>
              <span>{hourTR(x.hour_utc)}</span>
              <span>%{x.avg_view_pct} <span style={S.tiny}>n={x.sample_size}</span></span></div>
            <Bar pct={x.avg_view_pct/max*100} color={loop?C.gray:C.accent} h={6}/>
            {loop && <div style={S.tiny}>%100 üstü: Shorts döngüsü (tekrar izleme) — diğer saatlerle karşılaştırılamaz</div>}
            {few && <div style={S.tiny}>az örnek (n&lt;5), güvenilmez</div>}
          </div>; })}
        {rows.some(x=>x.sample_size<5) && <button onClick={()=>setShowAll(!showAll)} style={ghost({width:"100%",marginTop:6})}>
          {showAll?"Az örnekli saatleri gizle":`Az örnekli ${rows.filter(x=>x.sample_size<5).length} saati göster`}</button>}
        <div style={{...S.tiny,marginTop:6}}>Ortalama izlenme yüzdesi (Shorts + uzun karışık), video başına son ölçüm.</div>
      </>}
    </div>
  );
}

function QuotaLedger({h}) {
  const qd = h?.quota_detail||{};
  if(!h) return null;
  const L = {upload:"Yükleme",comment:"Yorum",low:"Düşük öncelik",maintenance:"Bakım",transfer:"Aktarım",stats:"Kanal toplamları"};
  return (
    <div style={S.card}>
      <div style={S.cardTitle}>📊 YouTube kota defteri</div>
      {qd.error ? <div style={{color:C.yellow,fontSize:13}}>{qd.error}</div> : <>
        <div style={{...S.small,marginBottom:6}}>PT günü {qd.pt_day} · toplam {fmtNum(qd.total)} / 10.000 birim</div>
        {Object.entries(qd).filter(([,v])=>v&&typeof v==="object"&&"cap" in v).sort(([a],[b])=>(b==="upload")-(a==="upload")).map(([k,v])=>{
          const pct=v.used/Math.max(1,v.cap)*100, full = k==="upload" ? h.quota_ok===false : pct>=100;
          return <div key={k} style={{marginBottom:8}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:14}}><span>{L[k]||k}</span><span>{fmtNum(v.used)} / {fmtNum(v.cap)}</span></div>
            <Bar pct={pct} color={full?(k==="upload"?C.red:C.gray):pct>=80?C.yellow:C.green}/>
            {k==="upload" && <div style={{...S.tiny,color:full?C.red:undefined}}>{full?"Yeni yükleme sığmıyor (bir yükleme ~2.100 birim)":`~${Math.floor((v.cap-v.used)/2100)} yükleme daha sığar`}</div>}
          </div>; })}
        <div style={S.tiny}>Düşük öncelik payının dolması normaldir (panel/analitik okumaları); yalnız yükleme payı dolarsa yükleme durur.</div>
      </>}
    </div>
  );
}

function Health({h, live, sys}) {
  const svc = {...(live?.services||{})};
  const SV = {"creatoros-worker":"Worker","creatoros-bot":"Telegram botu","creatoros-api":"Panel API",cron:"Cron"};
  if(sys?.services?.cron!=null) svc.cron = sys.services.cron;
  return (
    <div style={S.card}>
      <div style={S.cardTitle}>🩺 Sistem sağlığı</div>
      {Object.entries(svc).map(([k,v])=><div key={k} style={{...S.row,justifyContent:"space-between"}}>
        <span style={{display:"flex",gap:8,alignItems:"center"}}><Dot color={v?C.green:C.red}/>{SV[k]||k}</span><span style={{color:v?C.green:C.red}}>{v?"çalışıyor":"kapalı"}</span></div>)}
      {h?.ai_paid && <div style={{...S.small,marginTop:4}}>💳 Ücretli AI ({h.ai_paid.provider==="gemini"?"Google Gemini":h.ai_paid.provider==="groq"?"Groq":"yok"}): bu ay ${Number(h.ai_paid.month_usd||0).toFixed(2)} / ${Number(h.ai_paid.cap_usd||10).toFixed(0)} · senaryo ${Number(h.ai_paid.script_usd||0).toFixed(2)} $ · diğer işler ${Number(h.ai_paid.other_usd||0).toFixed(2)} $ · {h.ai_paid.state}</div>}
      {live && <div style={{...S.small,marginTop:4}}>RAM %{live.mem_pct} · son 24 saat {live.uploaded_24h} yükleme · {live.failed_24h} başarısız iş</div>}
      {h?.vision_status && Object.keys(h.vision_status.outage||{}).length>0 && <div style={{...S.small,color:C.yellow,marginTop:4}}>
        Görsel kontrol bugün devre dışı kaldı (reddedilen klip): {Object.entries(h.vision_status.outage).map(([c,n])=>`${c.replace(/^solaramade?/,"")||"solaramade"} ${n}`).join(", ")}</div>}
      {h?.panel_rss && <div style={{...S.tiny,marginTop:4}}>Kanal temposu RSS'ten okundu (düşük öncelik payı dolu); planlı/private videolar RSS'te görünmez.</div>}
      {sys && <Collapse title="Zamanlanmış işler (son çalışma)">
        {sys.crons.map(c=><div key={c.label} style={{...S.row,justifyContent:"space-between",minHeight:36}}>
          <span style={{display:"flex",gap:8,alignItems:"center"}}><Dot color={c.age_h==null?C.gray:c.ok?C.green:C.yellow}/><span className="wrap">{c.label}</span></span>
          <span style={{...S.tiny,whiteSpace:"nowrap"}}>{c.age_h==null?"log yok":c.age_h<1?`${Math.round(c.age_h*60)} dk önce`:`${c.age_h} sa önce`}</span></div>)}
        <div style={S.tiny}>Sarı: beklenen aralıktan uzun süredir log yazılmadı.</div>
      </Collapse>}
    </div>
  );
}

const QSTAT = {done:"yüklendi",failed:"başarısız",pending:"bekliyor",processing:"işleniyor",deferred:"ertelendi",held_review:"incelemede",
  cancelled_factcheck:"iptal: doğruluk",rejected_factcheck:"red: doğruluk",cancelled:"iptal",rendered:"hazır"};

function DiskQueue() {
  const [d] = useJSON("/api/disk-status");
  const [q] = useJSON("/api/queue-status",{refresh:60000});
  return <>
    {d && <div style={S.card}>
      <div style={S.cardTitle}>💾 Disk</div>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:14,marginBottom:6}}><span>{d.used_gb} / {d.total_gb} GB</span>
        <b style={{color:d.pct>85?C.red:d.pct>75?C.yellow:C.green}}>%{d.pct}</b></div>
      <Bar pct={d.pct} color={d.pct>85?C.red:d.pct>75?C.yellow:C.green}/>
      <div style={{...S.tiny,marginTop:4}}>{d.output_count} video dosyası</div></div>}
    {q && <div style={S.card}>
      <div style={S.cardTitle}>📋 Kuyruk</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:8}}>
        <Stat v={q.pending} l="bekliyor" color={C.yellow}/><Stat v={q.processing} l="işleniyor" color={C.blue}/><Stat v={q.failed} l="başarısız" color={C.red}/>
      </div>
      {(q.recent||[]).slice(0,6).map((v,i)=><div key={i} style={{...S.row,minHeight:36,justifyContent:"space-between",borderTop:`1px solid ${C.line}`}}>
        <span className="wrap" style={{fontSize:13,flex:1,minWidth:0}}>{String(v.title||"").slice(0,60)}</span>
        <span style={chip(v.status==="done"?C.green:v.status==="failed"?C.red:C.gray)}>{QSTAT[v.status]||v.status}</span></div>)}
    </div>}
  </>;
}

function Accounts({social, chStatus, onNotify}) {
  const [tiktokUrl] = useJSON("/api/tiktok/auth-url");
  if(!social) return null;
  const yt = social.youtube||{};
  return (
    <div style={S.card}>
      <div style={S.cardTitle}>🔑 Hesaplar ve tokenlar</div>
      <div style={{...S.row,justifyContent:"space-between"}}><span>YouTube</span>
        <span style={{color:yt.token_ok_channels===yt.total_channels?C.green:C.red}}>{yt.token_ok_channels}/{yt.total_channels} token</span></div>
      {(chStatus?.channels||[]).filter(c=>!c.token_ok).map(c=><div key={c.id} style={{...S.small,color:C.red}}>• {c.name}: token yok</div>)}
      <div style={{...S.row,justifyContent:"space-between",borderTop:`1px solid ${C.line}`}}><span>TikTok</span>
        <span style={{color:social.tiktok?.connected?C.green:C.red}}>{social.tiktok?.connected?"bağlı (taslak modu)":"bağlı değil"}</span></div>
      {!social.tiktok?.connected && tiktokUrl?.url && <a href={tiktokUrl.url} target="_blank" rel="noreferrer" style={{...btn("#ff2d55",{width:"100%"}),display:"flex",alignItems:"center",justifyContent:"center",textDecoration:"none"}}>TikTok'u bağla</a>}
      {(social.instagram?.accounts||[]).map(a=>(
        <div key={a.handle} style={{borderTop:`1px solid ${C.line}`,padding:"8px 0"}}>
          <div style={{display:"flex",justifyContent:"space-between"}}><span>{a.handle}</span>
            <span style={{color:a.status==="active"?C.green:a.status==="error"?C.red:C.gray}}>{a.status==="active"?"aktif":a.status==="error"?"hata":"bilinmiyor"}</span></div>
          <div style={S.tiny} className="wrap">{a.channels.map(c=>c.replace(/^solaramade?/,"")||"solaramade").join(", ")}</div>
          {a.status==="error" && a.last_failure && <div style={{...S.tiny,color:C.red}} className="wrap">{clean(a.last_failure).slice(0,140)}</div>}
        </div>))}
      <IgMapping onNotify={onNotify}/>
    </div>
  );
}

function IgMapping({onNotify}) {
  const [d] = useJSON("/api/ig/mapping");
  const [ch] = useJSON("/api/channels");
  const [map,setMap] = useState(null);
  useEffect(()=>{ if(d) setMap(d.mapping||{}); },[d]);
  if(!d || !ch || !map) return null;
  async function save() {
    const r = await postJSON("/api/ig/mapping",{mapping:map}).catch(()=>({}));
    onNotify(r.ok?"Eşleştirme kaydedildi":"Hata: "+(r.error||"?"), r.ok?"success":"error");
  }
  return (
    <Collapse title="Kanal → Instagram eşleştirme">
      {Object.keys(ch).filter(k=>ch[k].platform_type==="youtube").map(k=>(
        <div key={k} style={{...S.row,justifyContent:"space-between"}}>
          <span className="wrap" style={{fontSize:14,flex:1,minWidth:0}}>{ch[k].name||k}</span>
          <select value={map[k]||"official"} onChange={e=>setMap(m=>({...m,[k]:e.target.value}))} style={{...inp,width:"auto",maxWidth:"55%",fontSize:14}}>
            {Object.keys(d.accounts||{}).map(a=><option key={a} value={a}>{d.accounts[a]}</option>)}</select>
        </div>))}
      <button onClick={save} style={btn(C.accent,{width:"100%",marginTop:6})}>Kaydet</button>
    </Collapse>
  );
}

function RefreshAnalytics({onNotify}) {
  const [busy,setBusy] = useState(false);
  return <div>
    <div style={{...S.tiny,marginBottom:8}}>YouTube API kotası harcar; yalnız gerektiğinde kullan.</div>
    <button disabled={busy} style={btn(C.accent,{width:"100%"})} onClick={async()=>{ setBusy(true);
      await fetch(API+"/api/refresh-analytics",{method:"POST"}).catch(()=>{}); onNotify("Analitik yenileme başlatıldı","success"); setBusy(false); }}>
      {busy?"...":"Yenile"}</button></div>;
}

function NewChannel({onNotify}) {
  const [n,setN] = useState({id:"",name:"",template:"facts",language:"en"});
  async function create() {
    if(!n.id||!n.name){ onNotify("ID ve isim gerekli","error"); return; }
    const d = await postJSON("/api/channels/create",n).catch(()=>({}));
    if(d.ok){ onNotify("Kanal oluşturuldu: "+n.id,"success"); setN({id:"",name:"",template:"facts",language:"en"}); }
    else onNotify("Hata: "+(d.error||"?"),"error");
  }
  return <div>
    <input placeholder="Kanal ID (örn. solaramadecrime)" value={n.id} onChange={e=>setN({...n,id:e.target.value})} style={{...inp,marginBottom:8}}/>
    <input placeholder="Kanal adı (örn. Solaramade Crime)" value={n.name} onChange={e=>setN({...n,name:e.target.value})} style={{...inp,marginBottom:8}}/>
    <div style={{display:"flex",gap:8,marginBottom:8}}>
      <select value={n.template} onChange={e=>setN({...n,template:e.target.value})} style={inp}>
        {["mystery","facts","motivation","cats","wealth","stories"].map(t=><option key={t} value={t}>{t}</option>)}</select>
      <select value={n.language} onChange={e=>setN({...n,language:e.target.value})} style={inp}>
        <option value="en">English</option><option value="tr">Türkçe</option></select>
    </div>
    <button onClick={create} style={btn(C.green,{width:"100%"})}>Oluştur</button>
  </div>;
}

function Produce({onNotify}) {
  const PTABS = [
    {id:"yt_short",label:"YT Shorts"},{id:"yt_long",label:"YT Uzun"},{id:"tiktok",label:"TikTok"},
    {id:"ig_post",label:"IG Post"},{id:"ig_reel",label:"IG Reels"},{id:"reel_maker",label:"Alıntı Reels"},{id:"auto",label:"Otomatik"},
  ];
  const PLACEHOLDER = { yt_short:"Kısa video başlığı (en fazla 100 karakter)", yt_long:"Video başlığı (en fazla 100 karakter)",
    tiktok:"TikTok açıklaması + etiketler", ig_post:"Gönderi açıklaması", ig_reel:"Reels açıklaması" };
  const [ptab,setPtab] = useState("yt_short");
  const [file,setFile] = useState(null);
  const [title,setTitle] = useState("");
  const [channel,setChannel] = useState("");
  const [channels,setChannels] = useState([]);
  const [loading,setLoading] = useState(false);
  const [autoStatus,setAutoStatus] = useState(null);
  const [igAccount,setIgAccount] = useState("official");
  const [rm,setRm] = useState({channel:"",topic:"",account:"official",caption:"",video:null,quotes:[],busy:false});
  const fileRef = useRef();
  useEffect(()=>{ fetch(API+"/api/channels").then(r=>r.json()).then(d=>setChannels(Object.entries(d).map(([id,v])=>({id,...v})))).catch(()=>{}); },[]);
  const ytChannels = channels.filter(c=>c.active&&c.platform_type==="youtube");
  const reset = () => { setFile(null); setTitle(""); if(fileRef.current) fileRef.current.value=""; };
  async function send(url, fd, okField, okMsg) {
    setLoading(true);
    try { const d = await (await fetch(API+url,{method:"POST",body:fd})).json();
      if(d[okField]) onNotify(okMsg(d),"success"); else onNotify(d.error||"Hata","error"); }
    catch(e){ onNotify("Bağlantı hatası","error"); }
    setLoading(false); reset();
  }
  function uploadYT(isShort) {
    const fd = new FormData(); fd.append("file",file); fd.append("title",title); fd.append("channel",channel); fd.append("is_short",isShort?"1":"0");
    send("/api/upload-manual", fd, "url", d=>"Yüklendi: "+d.url);
  }
  function uploadTikTok() { const fd=new FormData(); fd.append("file",file); fd.append("title",title); send("/api/upload-tiktok",fd,"success",()=>"TikTok'a taslak olarak yüklendi"); }
  function uploadIG(type) { const fd=new FormData(); fd.append("file",file); fd.append("caption",title); fd.append("type",type); fd.append("account",igAccount);
    send("/api/upload-instagram",fd,"success",()=>"Instagram'a yüklendi"); }
  async function startAuto() {
    setLoading(true);
    try { const d = await postJSON("/api/produce",{channel:channel||"all"}); setAutoStatus(d); onNotify("Otomatik üretim başladı","success"); }
    catch(e){ onNotify("Bağlantı hatası","error"); }
    setLoading(false);
  }
  async function rmGenerate() {
    if(!rm.channel){ onNotify("Kanal seç","error"); return; }
    setRm(r=>({...r,busy:true,video:null,quotes:[]}));
    try { const d = await postJSON("/api/make-quote-reel",{channel:rm.channel,topic:rm.topic});
      if(d.ok){ setRm(r=>({...r,video:d.path,quotes:d.quotes||[]})); onNotify(`Reels üretildi (${d.cards} kart)`,"success"); } else onNotify(d.error||"Üretim hatası","error"); }
    catch(e){ onNotify("Bağlantı hatası","error"); }
    setRm(r=>({...r,busy:false}));
  }
  async function rmUpload() {
    setRm(r=>({...r,busy:true}));
    try { const blob = await (await fetch(API+"/api/file?path="+encodeURIComponent(rm.video))).blob();
      const fd = new FormData(); fd.append("file",blob,"reel.mp4"); fd.append("caption",rm.caption||rm.topic||""); fd.append("type","reel"); fd.append("account",rm.account);
      const d = await (await fetch(API+"/api/upload-instagram",{method:"POST",body:fd})).json();
      onNotify(d.success?"Instagram'a yüklendi":(d.error||"Yükleme hatası"), d.success?"success":"error"); }
    catch(e){ onNotify("Bağlantı hatası","error"); }
    setRm(r=>({...r,busy:false}));
  }
  const fileBox = (
    <div onClick={()=>fileRef.current&&fileRef.current.click()} style={{...S.card,borderStyle:"dashed",textAlign:"center",cursor:"pointer",marginBottom:8}}>
      <input ref={fileRef} type="file" accept="video/mp4,video/*,image/*" style={{display:"none"}} onChange={e=>setFile(e.target.files[0])}/>
      {file ? <div className="wrap" style={{color:C.green,fontSize:14}}>🎬 {file.name}</div> : <div style={S.small}>📁 Dosya seç</div>}
    </div>);
  const titleBox = (
    <div style={{marginBottom:8}}>
      <input style={inp} placeholder={PLACEHOLDER[ptab]||"Başlık"} maxLength={ptab.startsWith("yt")?100:2200} value={title} onChange={e=>setTitle(e.target.value)}/>
      {ptab.startsWith("yt") && <div style={{...S.tiny,textAlign:"right"}}>{title.length}/100</div>}
    </div>);
  const chSelect = (
    <select style={{...inp,marginBottom:8}} value={channel} onChange={e=>setChannel(e.target.value)}>
      <option value="">{ptab==="auto"?"Tüm kanallar":"Kanal seç..."}</option>
      {ytChannels.map(c=><option key={c.id} value={c.id}>{c.name||c.id}</option>)}</select>);
  const igSelect = (val,set) => (
    <select style={{...inp,marginBottom:8}} value={val} onChange={e=>set(e.target.value)}>
      <option value="official">@solaramade_official (ana)</option><option value="reels">@solaramade.reels</option><option value="media">@solaramade.media</option></select>);
  const go = (label, onClick, disabled, color=C.accent) => <button onClick={onClick} disabled={loading||disabled} style={btn(color,{width:"100%"})}>{loading?"Yükleniyor...":label}</button>;
  return (
    <div>
      <select value={ptab} onChange={e=>{setPtab(e.target.value); reset();}} style={{...inp,marginBottom:10}}>
        {PTABS.map(t=><option key={t.id} value={t.id}>{t.label}</option>)}</select>
      {ptab==="yt_short" && <>{fileBox}{titleBox}{chSelect}{go("YouTube Shorts yükle",()=>uploadYT(true),!file||!title||!channel)}</>}
      {ptab==="yt_long" && <>{fileBox}{titleBox}{chSelect}{go("YouTube uzun video yükle",()=>uploadYT(false),!file||!title||!channel)}</>}
      {ptab==="tiktok" && <>{fileBox}{titleBox}{go("TikTok'a taslak yükle",uploadTikTok,!file||!title,"#ff2d55")}</>}
      {ptab==="ig_post" && <>{igSelect(igAccount,setIgAccount)}{fileBox}{titleBox}{go("Instagram gönderisi yükle",()=>uploadIG("post"),!file||!title,"#e1306c")}</>}
      {ptab==="ig_reel" && <>{igSelect(igAccount,setIgAccount)}{fileBox}{titleBox}{go("Instagram Reels yükle",()=>uploadIG("reel"),!file||!title,"#833ab4")}</>}
      {ptab==="reel_maker" && <>
        <div style={{...S.tiny,marginBottom:8}}>Kanalın nişine uygun alıntı/bilgi kartları AI ile üretilir, arka plan otomatik seçilir.</div>
        <select style={{...inp,marginBottom:8}} value={rm.channel} onChange={e=>setRm(r=>({...r,channel:e.target.value}))}>
          <option value="">Kanal seç...</option>{channels.map(c=><option key={c.id} value={c.id}>{c.name||c.id}</option>)}</select>
        <input style={{...inp,marginBottom:8}} placeholder="Konu (isteğe bağlı, örn. sabah rutinleri)" value={rm.topic} onChange={e=>setRm(r=>({...r,topic:e.target.value}))}/>
        <button onClick={rmGenerate} disabled={rm.busy||!rm.channel} style={btn(C.accent,{width:"100%",marginBottom:8})}>{rm.busy?"Üretiliyor...":"Reels üret"}</button>
        {rm.video && <>
          <video src={API+"/api/file?path="+encodeURIComponent(rm.video)} controls playsInline style={{width:"100%",maxHeight:420,borderRadius:10,background:"#000"}}/>
          {rm.quotes.map((q,i)=><div key={i} className="wrap" style={S.tiny}>• {q}</div>)}
          <a href={API+"/api/file?path="+encodeURIComponent(rm.video)} download style={{display:"block",textAlign:"center",margin:"8px 0",fontWeight:700}}>⬇️ İndir</a>
          {igSelect(rm.account,v=>setRm(r=>({...r,account:v})))}
          <textarea style={{...inp,marginBottom:8,minHeight:80,fontFamily:"inherit"}} placeholder="Instagram açıklaması + etiketler" value={rm.caption} onChange={e=>setRm(r=>({...r,caption:e.target.value}))}/>
          <button onClick={rmUpload} disabled={rm.busy} style={btn("#833ab4",{width:"100%"})}>{rm.busy?"Yükleniyor...":"Instagram'a yükle"}</button>
        </>}
      </>}
      {ptab==="auto" && <>
        <div style={{...S.small,marginBottom:8}}>Seçilen kanal(lar) için otomatik üretimi hemen başlatır (konu seçimi, video, yükleme kuralları normal akıştaki gibi).</div>
        {chSelect}{go("Üretimi başlat",startAuto,false,C.green)}
        {autoStatus && <div className="wrap" style={{...S.tiny,marginTop:8,color:C.green}}>{JSON.stringify(autoStatus)}</div>}
      </>}
    </div>
  );
}

function Logs() {
  const T = ["produce","shorts","brain","scheduler","healing","analytics","system"];
  const [tab,setTab] = useState("produce");
  const [logs,,reload] = useJSON("/api/logs");
  const lines = (logs||{})[tab]||[];
  const col = l => l.includes("✅")?C.green:l.includes("❌")?C.red:(l.includes("⚠️")||l.includes("Duplicate"))?C.yellow:"rgba(255,255,255,0.7)";
  return <div>
    <div style={{display:"flex",gap:6,marginBottom:8}}>
      <select value={tab} onChange={e=>setTab(e.target.value)} style={{...inp,flex:1}}>{T.map(t=><option key={t} value={t}>{t} ({((logs||{})[t]||[]).length})</option>)}</select>
      <button onClick={reload} style={ghost()}>🔄</button></div>
    <div style={{fontFamily:"monospace",fontSize:11,maxHeight:420,overflowY:"auto",background:"rgba(0,0,0,0.3)",borderRadius:8,padding:8}}>
      {!logs ? <Loading/> : lines.length===0 ? <div style={S.tiny}>Log yok</div> :
        [...lines].reverse().map((l,i)=><div key={i} className="wrap" style={{color:col(l),padding:"2px 0",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>{l}</div>)}
    </div></div>;
}

function AIChat() {
  const [msg,setMsg] = useState("");
  const [chat,setChat] = useState([]);
  const [loading,setLoading] = useState(false);
  async function send() {
    if(!msg.trim()) return;
    const m = msg; setChat(c=>[...c,{role:"user",text:m}]); setMsg(""); setLoading(true);
    try { const d = await postJSON("/api/ai-chat",{message:m}); setChat(c=>[...c,{role:"ai",text:d.reply||d.error||"Cevap yok"}]); }
    catch(e){ setChat(c=>[...c,{role:"ai",text:"Bağlantı hatası"}]); }
    setLoading(false);
  }
  return <div>
    <div style={{minHeight:80,marginBottom:8}}>
      {chat.map((m,i)=><div key={i} style={{textAlign:m.role==="user"?"right":"left",marginBottom:6}}>
        <span className="wrap" style={{background:m.role==="user"?C.accent:"rgba(255,255,255,0.08)",padding:"8px 12px",borderRadius:10,fontSize:14,display:"inline-block",maxWidth:"85%",textAlign:"left"}}>{m.text}</span></div>)}
      {loading && <div style={S.tiny}>Yazıyor...</div>}
    </div>
    <div style={{display:"flex",gap:8}}><input style={{...inp,flex:1}} placeholder="Mesaj..." value={msg} onChange={e=>setMsg(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()}/>
      <button onClick={send} disabled={loading||!msg.trim()} style={btn()}>Gönder</button></div>
  </div>;
}

function Brain() {
  const [d] = useJSON("/api/brain");
  if(!d) return <Loading/>;
  const viral = d.viral_topics||[], hooks = d.top_hooks||[];
  return <div style={S.small}>
    {viral.slice(0,5).map((v,i)=><div key={i} style={{padding:"6px 0",borderTop:`1px solid ${C.line}`}}>
      <span style={chip(C.red)}>{v.niche}</span> <b className="wrap">{v.topic}</b><div style={S.tiny} className="wrap">{v.hook}</div></div>)}
    {hooks.length>0 && <div style={{marginTop:8}}><b>En iyi başlık kalıpları</b>{hooks.slice(0,5).map((h,i)=><div key={i} className="wrap" style={S.tiny}>• {h}</div>)}</div>}
    {!viral.length && !hooks.length && <div>Veri yok</div>}
  </div>;
}

// ─── GIRIS ────────────────────────────────────────────────────────────────
function Login({onDone}) {
  const [user,setUser] = useState("admin");
  const [pw,setPw] = useState("");
  const [err,setErr] = useState("");
  const [busy,setBusy] = useState(false);
  async function go(e) {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const r = await fetch(API+"/api/auth/login",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({username:user,password:pw})});
      const d = await r.json().catch(()=>({}));
      if(d.ok){ setPw(""); onDone(); } else setErr(d.error || (r.status===429?"Çok fazla deneme. Biraz bekle.":"Giriş yapılamadı"));
    } catch(e2) { setErr("Bağlantı hatası"); }
    setBusy(false);
  }
  return (
    <form onSubmit={go} style={{maxWidth:420,margin:"12vh auto 0",padding:"0 16px"}}>
      <h1 style={{fontSize:28,fontWeight:800,margin:"0 0 6px"}}>CreatorOS</h1>
      <div style={{...S.small,marginBottom:20}}>Devam etmek için giriş yap.</div>
      <label style={{...S.small,display:"block",marginBottom:6}}>Kullanıcı adı</label>
      <input style={{...inp,marginBottom:14}} autoComplete="username" value={user} onChange={e=>setUser(e.target.value)}/>
      <label style={{...S.small,display:"block",marginBottom:6}}>Parola</label>
      <input style={{...inp,marginBottom:14}} type="password" autoComplete="current-password" value={pw} onChange={e=>setPw(e.target.value)} autoFocus/>
      {err && <div role="alert" style={{color:C.red,fontWeight:700,fontSize:15,marginBottom:12}}>{err}</div>}
      <button type="submit" disabled={busy||!pw} style={btn(C.accent,{width:"100%",minHeight:52,fontSize:17})}>{busy?"...":"Giriş yap"}</button>
    </form>
  );
}

// ─── 1) BUGUN: sana dusen is ──────────────────────────────────────────────
function SecTitle({children, right}) {
  return <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",margin:"14px 2px 8px",gap:8}}>
    <h3 style={{fontSize:18,fontWeight:800,margin:0}}>{children}</h3>{right}</div>;
}

function TodoCard({it, onDone, onNotify}) {
  const [open,setOpen] = useState(false);
  const [busy,setBusy] = useState(false);
  async function mark() {
    setBusy(true);
    const d = await postJSON("/api/v2/uploaded",{id:it.id}).catch(()=>({}));
    setBusy(false);
    if(d.ok) onDone(it); else onNotify("İşaretlenemedi: "+(d.error||"bağlantı hatası"),"error");
  }
  const clamp = {display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"};
  return (
    <div style={{...S.card,padding:12,marginBottom:10}} data-todo={it.id}>
      <div style={{display:"flex",gap:10,alignItems:"center"}}>
        {it.thumb_url ? <img src={API+it.thumb_url} alt="" loading="lazy" style={{width:it.tall?36:64,height:it.tall?64:36,objectFit:"cover",borderRadius:6,flexShrink:0,background:"#222"}}/>
          : <div style={{width:36,height:64,borderRadius:6,background:"#222",flexShrink:0}}/>}
        <div style={{flex:1,minWidth:0}}>
          <div className="wrap" style={{fontSize:17,fontWeight:800,lineHeight:1.2}}>{it.channel_name} <span style={{...S.tiny,fontWeight:600}}>· {it.kind}</span></div>
          <div className="wrap" style={{fontSize:14,marginTop:2,lineHeight:1.3,color:C.dim,...clamp}}>{it.title}</div>
        </div>
        <button onClick={()=>setOpen(!open)} aria-label="Ayrıntı" style={ghost({padding:0,width:44,flexShrink:0})}>{open?"▲":"⋯"}</button>
      </div>
      <div style={{display:"flex",gap:8,marginTop:10}}>
        <a href={it.telegram_url} target="_blank" rel="noreferrer" style={{...ghost({flex:1,padding:"0 6px",fontSize:14}),display:"flex",alignItems:"center",
          justifyContent:"center",textDecoration:"none",color:"#fff",textAlign:"center"}}>Telegram'da paketi aç</a>
        <button onClick={mark} disabled={busy} style={btn(C.green,{flex:1,fontSize:16})}>{busy?"...":"Yükledim ✓"}</button>
      </div>
      {open && <div style={{marginTop:10}}>
        {it.note && <div className="wrap" style={{...S.small,marginBottom:6}}>{it.note}</div>}
        {it.auto_note && <div className="wrap" style={{...S.small,marginBottom:8}}>{it.auto_note}</div>}
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
          {it.is_youtube && <CopyBtn text={it.title} label="Başlık" onNotify={onNotify}/>}
          <CopyBtn text={it.description} label="Açıklama" onNotify={onNotify}/>
          {it.is_youtube && <CopyBtn text={it.tags} label="Etiketler" onNotify={onNotify}/>}
        </div>
        {it.is_youtube && <div style={{...S.small,marginBottom:8}}>
          {it.category && <div>Kategori: <b>{it.category}</b></div>}
          {it.playlists && <div className="wrap">Oynatma listesi: <b>{it.playlists}</b></div>}
          <div>Çocuklara özel: <b>{it.made_for_kids?"Evet":"Hayır"}</b></div>
          {(it.duration||it.size_mb) && <div style={S.tiny}>{it.duration||""}{it.size_mb?` · ${it.size_mb} MB`:""}</div>}
        </div>}
        {it.download_url && <a href={it.download_url} style={{...ghost({width:"100%"}),display:"flex",alignItems:"center",justifyContent:"center",
          textDecoration:"none",color:"#fff"}}>⬇️ Videoyu indir</a>}
      </div>}
    </div>
  );
}

function TodoSection({todo, onNotify, reload}) {
  const [hidden,setHidden] = useState({});
  const [undo,setUndo] = useState(null);
  const [all,setAll] = useState(false);
  const items = (todo?.items||[]).filter(u=>!hidden[u.id]);
  const shown = all ? items : items.slice(0,2);
  async function doUndo() {
    const u = undo; setUndo(null);
    const d = await postJSON("/api/v2/uploaded",{id:u.id,undo:true}).catch(()=>({}));
    if(d.ok){ setHidden(h=>{ const x={...h}; delete x[u.id]; return x; }); onNotify("Geri alındı","success"); reload(); }
    else onNotify("Geri alınamadı","error");
  }
  return <section aria-label="Bugün sana düşen iş">
    <SecTitle right={items.length?<span style={{...S.small,fontWeight:700}}>{items.length} paket</span>:null}>Bugün sana düşen iş</SecTitle>
    {items.length===0 ? <div style={{...S.card,display:"flex",gap:10,alignItems:"center",fontSize:17,fontWeight:700,borderColor:COL.green+"55"}}>
        <span>Bugün yapman gereken bir şey yok ✅</span></div>
      : shown.map(it=><TodoCard key={it.id} it={it} onNotify={onNotify}
          onDone={x=>{ setHidden(h=>({...h,[x.id]:true})); setUndo(x); onNotify("Yüklendi olarak işaretlendi","success");
            setTimeout(()=>setUndo(v=>v&&v.id===x.id?null:v),10000); }}/>)}
    {items.length>2 && <button onClick={()=>setAll(!all)} style={ghost({width:"100%",marginBottom:10})}>{all?"Daha az göster":`Tüm paketleri göster (+${items.length-2})`}</button>}
    {undo && <div style={{...S.card,...S.row,justifyContent:"space-between"}}>
      <span className="wrap" style={S.small}>“{String(undo.title).slice(0,40)}” yüklendi olarak işaretlendi</span>
      <button onClick={doUndo} style={ghost()}>Geri al</button></div>}
    {todo?.later>0 && <div style={{...S.small,margin:"-4px 2px 4px"}}>Yarın sabah Telegram'a {todo.later} paket daha gelecek.</div>}
  </section>;
}

// ─── 1b) YAYIN TAKVİMİ (GOREV348) ─────────────────────────────────────────
const CAL_COL = {planned:COL.green, held:COL.yellow, public:COL.green, problem:COL.red};
function CalCard({it, onAct, busy}) {
  const tall = it.format==="Shorts";
  const col = CAL_COL[it.status]||C.dim;
  return (
    <div style={{...S.card,padding:12,marginBottom:10,minWidth:0,overflow:"hidden"}} data-cal={it.id}>
      <div style={{display:"flex",gap:10,alignItems:"flex-start",minWidth:0}}>
        {it.thumb_url ? <img src={it.thumb_url.startsWith("http")?it.thumb_url:API+it.thumb_url} alt="" loading="lazy"
            style={{width:tall?36:64,height:tall?64:36,objectFit:"cover",borderRadius:6,flexShrink:0,background:"#222"}}/>
          : <div style={{width:tall?36:64,height:tall?64:36,borderRadius:6,background:"#222",flexShrink:0}}/>}
        <div style={{flex:1,minWidth:0}}>
          <div className="wrap" style={{fontSize:16,fontWeight:800,lineHeight:1.2}}>
            {it.focus && <span title="Odak kanal" aria-label="Odak kanal">⭐ </span>}{it.channel_name} <span style={{...S.tiny,fontWeight:600}}>· {it.format}</span></div>
          <div className="wrap" style={{fontSize:14,marginTop:3,lineHeight:1.3,color:C.dim}}>{it.title}</div>
        </div>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginTop:8}}>
        <span style={{fontSize:15,fontWeight:700}}>{it.when}</span>
        <span style={S.small}>· {it.countdown}</span>
        <span style={{marginLeft:"auto",fontSize:13,fontWeight:700,color:col,border:`1px solid ${col}66`,borderRadius:999,padding:"2px 10px",whiteSpace:"nowrap"}}>{it.badge}</span>
      </div>
      {it.reason && <div className="wrap" style={{...S.small,marginTop:6,color:it.status==="problem"?col:C.dim}}>{it.reason}</div>}
      {(it.preview_url||it.can_hold||it.can_publish) && <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
        {it.preview_url && <a href={it.preview_url} target="_blank" rel="noreferrer" style={{...ghost({flex:1,minWidth:90,padding:"0 6px",fontSize:14}),display:"flex",alignItems:"center",
          justifyContent:"center",textDecoration:"none",color:"#fff"}}>▶️ Önizle</a>}
        {it.can_hold && <button disabled={busy} onClick={()=>onAct(it,"hold")} style={btn(COL.yellow,{flex:1,minWidth:90,fontSize:15,color:"#111"})}>{busy?"...":"⏸ Beklet"}</button>}
        {it.can_publish && <button disabled={busy} onClick={()=>onAct(it,"publish")} style={btn(C.green,{flex:1,minWidth:90,fontSize:15})}>{busy?"...":"▶️ Yayınla"}</button>}
      </div>}
    </div>
  );
}

function HealthCard({h}) {
  if(!h) return null;
  const col = {green:"#1f9d55",yellow:"#d69e2e",red:"#d64545"}[h.color]||"#d69e2e";
  const lines = (h.text||"").split("\n").map(x=>x.replace(/<[^>]+>/g,""));
  return <section aria-label="Sistem sağlığı">
    <SecTitle>Sistem sağlığı</SecTitle>
    <div style={{...S.card,borderLeft:"6px solid "+col}}>
      {lines.map((l,i)=><div key={i} className="wrap" style={{fontSize:i===0?15:14,fontWeight:i===0?700:400,marginTop:i?4:0}}>{l}</div>)}
    </div>
  </section>;
}

function CalendarSection({cal, onNotify, reload}) {
  const [busy,setBusy] = useState(null);
  const [all,setAll] = useState(false);
  const [rec,setRec] = useState(false);
  if(!cal) return null;
  const items = cal.items||[];
  const shown = all ? items : items.slice(0,8);
  async function onAct(it, action) {
    if(action==="publish" && !window.confirm("Bu video şimdi herkese açık olacak. Devam edilsin mi?")) return;
    setBusy(it.id);
    const d = await postJSON("/api/v3/calendar/action",{vid:it.vid,action}).catch(()=>({}));
    setBusy(null);
    onNotify(d.message||"İşlem yapılamadı", d.ok?"success":"error");
    reload();
  }
  return <section aria-label="Yayın takvimi">
    <SecTitle>Yayın takvimi</SecTitle>
    <div className="wrap" style={{...S.small,margin:"-4px 2px 8px"}}>{cal.description}</div>
    <div style={{...S.card,fontSize:15,fontWeight:700,marginBottom:10}}>{items.length?cal.summary:(cal.empty_reason||"Önümüzdeki 48 saate planlı video yok.")}</div>
    {shown.map(it=><CalCard key={it.id} it={it} onAct={onAct} busy={busy===it.id}/>)}
    {items.length>8 && <button onClick={()=>setAll(!all)} style={ghost({width:"100%",marginBottom:10})}>{all?"Daha az göster":`Tümünü göster (+${items.length-8})`}</button>}
    <button onClick={()=>setRec(!rec)} aria-expanded={rec} style={ghost({width:"100%",marginBottom:10,justifyContent:"space-between",display:"flex",alignItems:"center",padding:"0 14px"})}>
      <span>Son yayınlananlar ({(cal.recent||[]).length})</span><span>{rec?"▲":"▼"}</span></button>
    {rec && <div style={{marginBottom:10}}>
      {(cal.recent||[]).length===0 ? <div style={{...S.card,...S.small}}>Son 48 saatte yayınlanan video yok.</div>
        : (cal.recent||[]).map(it=><div key={it.id} style={{...S.card,padding:12,marginBottom:8,minWidth:0}}>
            <div className="wrap" style={{fontSize:15,fontWeight:700}}>{it.focus?"⭐ ":""}{it.channel_name} <span style={{...S.tiny,fontWeight:600}}>· {it.format}</span></div>
            <div className="wrap" style={{fontSize:14,color:C.dim,marginTop:2}}>{it.title}</div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginTop:6}}>
              <span style={S.small}>{it.when}</span>
              <span style={S.small}>· {it.views!=null?`${it.views} izlenme`:"izlenme henüz yok"}</span>
              {it.preview_url && <a href={it.preview_url} target="_blank" rel="noreferrer" style={{marginLeft:"auto",color:COL.green,fontWeight:700,textDecoration:"none"}}>Aç ↗</a>}
            </div></div>)}
    </div>}
  </section>;
}

// ─── 2) KANALLAR TEK BAKISTA ──────────────────────────────────────────────
function ChannelInfo({ch}) {
  const [d] = useJSON(`/api/v3/channel?ch=${encodeURIComponent(ch)}`);
  if(!d) return <Loading/>;
  if(!d.ok) return <div style={S.small}>Bilgi alınamadı.</div>;
  return <div style={{...S.small,padding:"4px 0 8px 24px"}}>
    <div><b>{d.tier}</b></div>
    <div className="wrap">{d.plan}</div>
    <div style={{marginTop:8,fontWeight:700,color:"#fff"}}>Son 5 video</div>
    {(d.videos||[]).length===0 ? <div>Henüz yayınlanmış video yok.</div> : d.videos.map(v=>(
      <div key={v.video_id} style={{padding:"6px 0",borderTop:`1px solid ${C.line}`}}>
        <a href={`https://youtu.be/${v.video_id}`} target="_blank" rel="noreferrer" className="wrap" style={{color:"#fff",textDecoration:"none",fontSize:14}}>{v.title}</a>
        <div style={S.tiny}>{v.published} · {v.views==null?"izlenme verisi henüz yok":`${fmtNum(v.views)} izlenme`}{v.avg_view?` · ortalama izlenme süresi ${v.avg_view}`:""}</div>
      </div>))}
    {(d.formula||[]).length>0 && <div style={{marginTop:8}}>
      <div style={{fontWeight:700,color:"#fff"}}>Rakiplerde işe yarayan</div>
      {d.formula.map((l,i)=><div key={i} className="wrap">• {l}</div>)}
      <div style={S.tiny}>{d.formula_note}</div></div>}
    {(d.formula||[]).length===0 && <div style={{...S.tiny,marginTop:8}}>{d.formula_note}</div>}
    {d.retention && <div className="wrap" style={{marginTop:6}}>{d.retention}</div>}
  </div>;
}

function ChannelLine({r, children}) {
  const [open,setOpen] = useState(false);
  return <div style={{borderTop:`1px solid ${C.line}`}}>
    <button onClick={()=>setOpen(!open)} aria-expanded={open} data-ch={r.id} style={{display:"flex",gap:12,alignItems:"flex-start",width:"100%",background:"none",
      border:"none",color:"#fff",textAlign:"left",padding:"12px 0",minHeight:56,cursor:"pointer"}}>
      <span style={{marginTop:5}}><span style={{width:14,height:14,borderRadius:7,background:COL[r.color],display:"inline-block"}}/></span>
      <span style={{flex:1,minWidth:0}}>
        <span className="wrap" style={{display:"block",fontSize:16,fontWeight:700}}>{r.name}</span>
        <span className="wrap" style={{display:"block",fontSize:14,color:r.color==="green"?C.dim:COL[r.color],marginTop:2,lineHeight:1.35}}>{r.status}</span>
      </span>
      <span style={{color:C.faint,fontSize:13,marginTop:4}}>{open?"▲":"▼"}</span>
    </button>
    {open && <><ChannelInfo ch={r.id}/>{children}</>}
  </div>;
}

function ChannelsGlance({rows}) {
  const n = {red:0,yellow:0,green:0}; (rows||[]).forEach(r=>{ n[r.color]++; });
  return <section aria-label="Kanallar">
    <SecTitle right={<span style={{...S.small,display:"flex",gap:10}}>
      {["green","yellow","red"].filter(k=>n[k]).map(k=><span key={k} style={{color:COL[k],fontWeight:700}}>● {n[k]}</span>)}</span>}>Kanallar</SecTitle>
    <div style={{...S.card,padding:"0 14px"}}>
      {(rows||[]).map((r,i)=><div key={r.id} style={i===0?{marginTop:-1}:null}><ChannelLine r={r}/></div>)}
    </div>
    <div style={{...S.tiny,margin:"-4px 2px 0"}}>● yeşil: plana uygun · ● sarı: gecikme var, sistem hallediyor · ● kırmızı: 3 günlük video tabanı tehlikede ya da senin işin var</div>
  </section>;
}

// ─── 3) BUYUME ────────────────────────────────────────────────────────────
function MoneyBars({m}) {
  const hours = m.path==="hours";
  return <div style={{marginTop:8}}>
    <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}><span>Abone</span><b>{fmtNum(m.subs)} / {fmtNum(m.subs_goal)}</b></div>
    <Bar pct={m.subs_pct} color={C.yellow} h={7}/>
    <div style={{display:"flex",justifyContent:"space-between",fontSize:13,marginTop:6,gap:8}}>
      <span>{hours?"İzlenme saati (365 gün)":"Shorts izlenmesi (90 gün)"}</span>
      <b style={{whiteSpace:"nowrap"}}>{hours?`${String(m.hours).replace(".",",")} / ${fmtNum(m.hours_goal)}`:`${fmtNum(m.shorts)} / 10 milyon`}</b></div>
    <Bar pct={hours?m.hours/m.hours_goal*100:m.shorts/m.shorts_goal*100} color="#f472b6" h={7}/>
    <div style={{...S.tiny,marginTop:2}}>Diğer yol: {hours?`Shorts ${fmtNum(m.shorts)} / 10 milyon`:`izlenme saati ${String(m.hours).replace(".",",")} / 4.000`}</div>
    <div className="wrap" style={{fontSize:13,marginTop:4,color:m.eta!=null?C.green:C.dim}}>⏱ {m.eta_text}</div>
  </div>;
}

function GrowthRow({g}) {
  const ch = g.change||"";
  const neg = ch.startsWith("−");
  return <div style={{padding:"10px 0",borderTop:`1px solid ${C.line}`}}>
    <div style={{display:"flex",justifyContent:"space-between",gap:8,alignItems:"baseline"}}>
      <span className="wrap" style={{fontSize:16,fontWeight:700}}>{g.name}</span>
      <span style={{fontSize:14,whiteSpace:"nowrap"}}><b>{fmtNum(g.subs)}</b> abone</span></div>
    <div className="wrap" style={{...S.small}}>28 günde {fmtNum(g.views_28)} izlenme · <span style={{color:neg?C.red:C.green,fontWeight:700}}>{ch}</span> önceki 28 güne göre</div>
    <MoneyBars m={g.money}/>
  </div>;
}

function GrowthSection({g}) {
  const [all,setAll] = useState(false);
  const rows = [...(g?.rows||[])].sort((a,b)=>(b.money?.subs_pct||0)-(a.money?.subs_pct||0));
  const vis = all ? rows : rows.slice(0,3);
  return <section aria-label="Büyüme">
    <SecTitle>Büyüme</SecTitle>
    <div style={S.card}>
      <div style={{fontSize:14}}>
        <div className="wrap">📈 <b>En hızlı büyüyen:</b> {(g?.fastest||[]).map(x=>`${x.name} (${x.text})`).join(", ")}</div>
        <div className="wrap" style={{marginTop:6}}>🐢 <b>En yavaş:</b> {(g?.slowest||[]).map(x=>`${x.name} (${x.text})`).join(", ")}</div>
      </div>
      <div style={{...S.tiny,marginTop:8}}>Para kazanma şartı: 1.000 abone ve (son 365 günde 4.000 saat uzun video izlenmesi ya da son 90 günde 10 milyon Shorts izlenmesi). Tahmin son 28 günün hızıyla.</div>
      {vis.map(x=><GrowthRow key={x.id} g={x}/>)}
      {rows.length>3 && <button onClick={()=>setAll(!all)} style={ghost({width:"100%",marginTop:8})}>{all?"Daha az göster":`Tüm kanallar (${rows.length})`}</button>}
    </div>
  </section>;
}

// ─── 4) SORUNLAR ──────────────────────────────────────────────────────────
function ProblemsSection({list, onNotify}) {
  return <section aria-label="Sorunlar">
    <SecTitle>Sorunlar</SecTitle>
    {(list||[]).length===0 ? <div style={{...S.card,fontSize:16,fontWeight:700,borderColor:COL.green+"55"}}>Açık sorun yok ✅</div>
      : <div style={{...S.card,padding:"0 14px"}}>{list.map((p,i)=>(
        <div key={i} style={{display:"flex",gap:12,padding:"12px 0",borderTop:i?`1px solid ${C.line}`:"none"}}>
          <span style={{marginTop:5}}><span style={{width:12,height:12,borderRadius:6,background:COL[p.level],display:"inline-block"}}/></span>
          <div style={{minWidth:0,flex:1}}>
            <div className="wrap" style={{fontSize:15,fontWeight:700,lineHeight:1.35}}>{p.what}</div>
            <div className="wrap" style={{...S.small,marginTop:3}}>Sistem ne yapıyor: {p.system}</div>
            <div className="wrap" style={{fontSize:14,marginTop:3,fontWeight:p.level==="red"?700:400,color:p.level==="red"?COL.red:C.dim}}>
              {String(p.need).startsWith("Evet")?`Senden gereken: ${p.need.replace(/^Evet\s*—\s*/,"")}`:"Senden bir şey gerekmiyor."}</div>
            {p.action?.link && <a href={p.action.link} target="_blank" rel="noreferrer" style={{fontSize:14}}>Studio'da aç</a>}
            {p.action?.kind==="dup_override" && <button style={ghost({marginTop:8,width:"100%"})} onClick={async()=>{
              const d = await postJSON("/api/v2/dup-override",{key:p.action.key}).catch(()=>({}));
              onNotify(d.ok?"Farklı video olarak işaretlendi — otomatik yüklenecek":"İşaretlenemedi", d.ok?"success":"error"); }}>
              Farklı video, otomatik yüklensin</button>}
          </div>
        </div>))}</div>}
  </section>;
}

function Today({onNotify}) {
  const [d,,reload] = useJSON("/api/v3/home",{refresh:5*60000});
  return <div>
    <Header title="Özet" sub={new Date().toLocaleDateString("tr-TR",{timeZone:TZ,weekday:"long",day:"numeric",month:"long"})}
      right={<button onClick={reload} aria-label="Yenile" style={ghost({padding:"0 14px"})}>↻</button>}/>
    {!d ? <div style={S.card}><Loading text="Durum hazırlanıyor..."/></div> : <>
      <TodoSection todo={d.todo} onNotify={onNotify} reload={reload}/>
      <HealthCard h={d.health}/>
      <CalendarSection cal={d.calendar} onNotify={onNotify} reload={reload}/>
      <ChannelsGlance rows={d.channels}/>
      <GrowthSection g={d.growth}/>
      <ProblemsSection list={d.problems} onNotify={onNotify}/>
      <div style={{...S.tiny,textAlign:"center",margin:"14px 0"}}>Son güncelleme: {trTime(d.at)}</div>
    </>}
  </div>;
}


// ─── ANA SAYFA: büyük renkli rakam kutuları (6 Eylül paneli tarzı) ───────────
const TILE = { green:C.green, yellow:C.yellow, red:C.red, blue:C.blue, purple:"#a78bfa", gray:"#64748b" };

const GRID_CSS = `
.tgrid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
.tgrid .span2{grid-column:span 2}
@media(min-width:640px){.tgrid{grid-template-columns:repeat(3,minmax(0,1fr))}.tgrid .span2{grid-column:span 3}}
@media(min-width:960px){.tgrid{grid-template-columns:repeat(4,minmax(0,1fr))}.tgrid .span2{grid-column:span 4}}
.tile{background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);border-radius:16px;padding:14px 12px;text-align:center;cursor:pointer;
  display:flex;flex-direction:column;justify-content:center;align-items:center;min-height:104px;min-width:0;color:inherit;font-family:inherit;width:100%}
.tile:active{background:rgba(255,255,255,0.09)}
`;

function Tile({b, onGo, onGoal}) {
  const col = TILE[b.c] || C.blue;
  const hasVal = b.v!==null && b.v!==undefined;
  const big = String(b.v||"").length;
  const fs = b.small ? 20 : big>9 ? 22 : big>6 ? 28 : 36;
  const wide = !!b.list;
  return (
    <button className={"tile"+(wide?" span2":"")} data-tile={b.l} onClick={()=>b.tab && onGo && onGo(b.tab)} style={{borderColor:hasVal?col+"44":C.line}}>
      {!wide && (hasVal
        ? <div className="wrap" style={{fontSize:fs,fontWeight:800,color:col,lineHeight:1.1}}>{b.v}</div>
        : <div style={{fontSize:30,fontWeight:800,color:TILE.gray,lineHeight:1.1}}>–</div>)}
      <div style={{fontSize:12,color:C.dim,marginTop:5,fontWeight:wide?700:400,lineHeight:1.25}} className="wrap">{b.l}</div>
      {b.bar!=null && <div style={{width:"100%",marginTop:7}}><Bar pct={b.bar} color={col} h={6}/></div>}
      {b.video && <div style={{display:"flex",gap:8,alignItems:"center",marginTop:6,width:"100%"}}>
        <img src={`https://i.ytimg.com/vi/${b.video.id}/mqdefault.jpg`} alt="" loading="lazy" style={{width:56,height:32,objectFit:"cover",borderRadius:5,background:"#222",flexShrink:0}}/>
        <span className="wrap" style={{fontSize:11,color:C.faint,textAlign:"left",lineHeight:1.2,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{b.video.title}</span></div>}
      {b.s && <div style={{fontSize:11,color:C.faint,marginTop:4,lineHeight:1.3}} className="wrap">{b.s}</div>}
      {b.list && <div style={{width:"100%",marginTop:6,textAlign:"left"}}>
        {b.list.map((x,i)=><div key={i} style={{padding:"6px 0",borderTop:i?`1px solid ${C.line}`:"none"}}>
          <div className="wrap" style={{fontSize:13,fontWeight:600}}>{x.id?<a href={`https://youtu.be/${x.id}`} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()} style={{color:"#fff",textDecoration:"none"}}>{x.text}</a>:x.text}</div>
          <div style={{fontSize:11,color:C.faint}} className="wrap">{x.sub}</div></div>)}</div>}
      {b.editable && <span onClick={e=>{ e.stopPropagation(); onGoal&&onGoal(b.goal); }} style={{fontSize:12,color:C.accent,marginTop:6,fontWeight:700}}>✎ Hedefi değiştir</span>}
    </button>
  );
}

function LineChart({days, series, color, title, fmt=fmtNum}) {
  const v = series.map(x=>x==null?null:Number(x));
  const ok = v.filter(x=>x!=null);
  if(ok.length<2) return null;
  const W=300,H=90,P=4, mn=Math.min(...ok), mx=Math.max(...ok), rg=(mx-mn)||1;
  const pts = v.map((x,i)=>x==null?null:[P+i*(W-2*P)/(v.length-1), H-P-(x-mn)/rg*(H-2*P)]).filter(Boolean);
  const dpath = pts.map((p,i)=>(i?"L":"M")+p[0].toFixed(1)+" "+p[1].toFixed(1)).join(" ");
  return <div className="tile span2" style={{cursor:"default",alignItems:"stretch",textAlign:"left"}}>
    <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:C.dim}}><b>{title}</b><span>{fmt(ok[ok.length-1])}</span></div>
    <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={title} style={{width:"100%",height:90,marginTop:6}} preserveAspectRatio="none">
      <path d={dpath+` L${pts[pts.length-1][0]} ${H-P} L${pts[0][0]} ${H-P} Z`} fill={color+"22"}/>
      <path d={dpath} fill="none" stroke={color} strokeWidth="2" vectorEffect="non-scaling-stroke"/></svg>
    <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:C.faint}}><span>{days[0].slice(5)}</span><span>en düşük {fmt(mn)} · en yüksek {fmt(mx)}</span><span>{days[days.length-1].slice(5)}</span></div>
  </div>;
}

function Compare({rows, note}) {
  if(!rows||!rows.length) return null;
  const mx = Math.max(1,...rows.map(r=>r.views));
  return <div className="tile span2" style={{cursor:"default",alignItems:"stretch",textAlign:"left"}}>
    <div style={{fontSize:12,color:C.dim,fontWeight:700,marginBottom:6}}>Kanalların büyüme karşılaştırması</div>
    {rows.map((r,i)=><div key={i} style={{padding:"3px 0"}}>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:12,gap:8}}><span className="wrap">{r.name}</span>
        <span style={{whiteSpace:"nowrap"}}><b>{fmtNum(r.views)}</b> {r.pct!=null && <span style={{color:r.pct>=0?C.green:C.red}}>{r.pct>=0?"+":"−"}%{Math.abs(r.pct)}</span>}</span></div>
      <Bar pct={r.views/mx*100} color={r.pct!=null&&r.pct<0?C.red:C.green} h={6}/></div>)}
    <div style={{fontSize:10,color:C.faint,marginTop:4}}>{note}</div>
  </div>;
}

function PlatformSplit({sp}) {
  if(!sp) return null;
  const tot = sp.rows.reduce((a,r)=>a+(r.views||0),0);
  return <div className="tile span2" style={{cursor:"default",alignItems:"stretch",textAlign:"left"}}>
    <div style={{fontSize:12,color:C.dim,fontWeight:700,marginBottom:6}}>Platformlara göre toplam izlenme</div>
    {sp.rows.map((r,i)=><div key={i} style={{padding:"3px 0"}}>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:12,gap:8}}><span>{r.name}</span>
        <b style={{color:r.views==null?C.faint:"#fff",textAlign:"right"}}>{r.views==null?(r.note||"veri yok"):`${fmtNum(r.views)} (%${tot?Math.round(r.views/tot*100):0})`}</b></div>
      {r.views!=null && r.note && <div style={{fontSize:10,color:C.faint,overflowWrap:"anywhere"}}>{r.note}</div>}
      <Bar pct={r.views&&tot?r.views/tot*100:0} color={C.accent} h={6}/></div>)}
    <div style={{fontSize:10,color:C.faint,marginTop:4}}>{sp.note}</div>
  </div>;
}

function Sec({title, children}) {
  return <section aria-label={title}><SecTitle>{title}</SecTitle>{children}</section>;
}

function DashSections({d, keys, onGo, onGoal}) {
  return <>{(d.sections||[]).filter(s=>!keys||keys.includes(s.key)).map(s=>(
    <Sec key={s.key} title={s.title}>
      <div className="tgrid">
        {s.boxes.map((b,i)=><Tile key={i} b={b} onGo={onGo} onGoal={onGoal}/>)}
        {s.charts && <>
          {s.charts.views && <LineChart days={s.charts.days} series={s.charts.views} color={C.purple||"#a78bfa"} title="Son 30 gün izlenme (günlük)"/>}
          {s.charts.subs && <LineChart days={s.charts.days} series={s.charts.subs} color={C.blue} title="Son 30 gün toplam abone"/>}
          <Compare rows={s.charts.compare} note={s.charts.compare_note}/></>}
        {s.split && <PlatformSplit sp={s.split}/>}
      </div>
    </Sec>))}</>;
}

function useGoal(onNotify, reload) {
  return async (cur) => {
    const v = window.prompt("Aylık abone hedefi (sayı):", String(cur||""));
    if(v==null) return;
    const d = await postJSON("/api/v4/goal",{monthly_subs:Number(v)}).catch(()=>({}));
    if(d.ok){ onNotify("Hedef güncellendi","success"); reload(); } else onNotify(d.error||"Kaydedilemedi","error");
  };
}

function HomeDash({onNotify, onGo}) {
  const [d,err,reload] = useJSON("/api/v4/dash",{refresh:10*60000});
  const [h,,reloadH] = useJSON("/api/v3/home",{refresh:5*60000});
  const goal = useGoal(onNotify, reload);
  return <div>
    <style>{GRID_CSS}</style>
    <Header title="Ana Sayfa" sub={new Date().toLocaleDateString("tr-TR",{timeZone:TZ,weekday:"long",day:"numeric",month:"long"})}
      right={<button onClick={reload} aria-label="Yenile" style={ghost({padding:"0 14px"})}>↻</button>}/>
    {!d ? <div style={S.card}><Loading text={err?"Veri alınamadı":"Durum hazırlanıyor..."}/></div> : <>
      <DashSections d={d} keys={["ozet"]} onGo={onGo}/>
      {(h?.todo?.items||[]).length>0 && <TodoSection todo={h.todo} onNotify={onNotify} reload={()=>{reload();reloadH();}}/>}
      <DashSections d={d} keys={["buyume","is","kanallar","izleyici","kalite","platform","gelir","hedef","trend","uyari","sistem"]} onGo={onGo} onGoal={goal}/>
      <div style={{...S.tiny,textAlign:"center",margin:"14px 0"}}>Son güncelleme: {trTime(d.at)} · Saatler Türkiye saati</div>
    </>}
  </div>;
}

function ChannelCards({cards}) {
  if(!cards||!cards.length) return null;
  return <div className="tgrid" style={{marginBottom:12}}>
    {cards.map(c=><div key={c.id} className="tile" style={{cursor:"default",alignItems:"stretch",textAlign:"left",borderColor:COL[c.color]+"55"}}>
      <div style={{display:"flex",gap:6,alignItems:"center",fontSize:13,fontWeight:700}}><Dot color={COL[c.color]}/><span className="wrap">{c.name}</span></div>
      <div style={{fontSize:30,fontWeight:800,color:C.blue,lineHeight:1.15,marginTop:4}}>{c.subs==null?"–":fmtNum(c.subs)}</div>
      <div style={{fontSize:11,color:C.dim}}>abone</div>
      <div style={{fontSize:20,fontWeight:800,color:"#a78bfa",marginTop:4}}>{c.views_28==null?"–":fmtNum(c.views_28)}</div>
      <div style={{fontSize:11,color:C.dim}}>28 gün izlenme</div>
      <div style={{fontSize:11,color:C.faint,marginTop:5}} className="wrap">Son video: {c.last_video||"yok"}</div>
      <div style={{fontSize:11,color:C.faint}} className="wrap">Plan: {c.plan||"–"}</div>
    </div>)}
  </div>;
}

// ─── KANALLAR SEKMESI ─────────────────────────────────────────────────────
function Channels({onNotify}) {
  const [d] = useJSON("/api/v3/home");
  const [dash] = useJSON("/api/v4/dash");
  const [st,,reloadSt] = useJSON("/api/channels/status");
  const ST = {}; (st?.channels||[]).forEach(c=>{ ST[c.id]=c; });
  return <div>
    <Header title="Kanallar" sub="Dokun: plan, kademe, son videolar, rakiplerde işe yarayan"/>
    <style>{GRID_CSS}</style>
    <ChannelCards cards={dash?.channel_cards}/>
    {!d ? <Loading/> : <div style={{...S.card,padding:"0 14px"}}>
      {(d.channels||[]).map(r=><ChannelLine key={r.id} r={r}>
        {ST[r.id] && <div style={{paddingLeft:24,paddingBottom:8}}><ChannelManage c={ST[r.id]} onNotify={onNotify} reload={reloadSt}/></div>}
      </ChannelLine>)}
    </div>}
    <Comments onNotify={onNotify}/>
  </div>;
}

// ─── BUYUME SEKMESI ───────────────────────────────────────────────────────
function Growth() {
  const [dash] = useJSON("/api/v4/dash");
  const [g] = useJSON("/api/v3/growth");
  const [h] = useJSON("/api/v3/home");
  const [gr] = useJSON("/api/v2/growth?light=1");
  if(!g) return <><Header title="Büyüme"/><Loading/></>;
  const H = {}; (h?.growth?.rows||[]).forEach(x=>{ H[x.id]=x; });
  return <div>
    <Header title="Büyüme" sub="Son 28 gün (YouTube Analytics, günlük)"/>
    <style>{GRID_CSS}</style>
    {dash && <DashSections d={dash} keys={["buyume","hedef","gelir","trend"]} onGo={()=>{}} onGoal={()=>{}}/>}
    {(g.retention_overall||[]).length>0 && <div style={S.card}>
      <div style={S.cardTitle}>Bizim videolarda izleyici nerede gidiyor</div>
      {g.retention_overall.map((c,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",gap:8,fontSize:14,padding:"4px 0"}}>
        <span className="wrap">{c.label}</span><b>%{Math.round(c.share)}</b></div>)}
      <div style={S.tiny}>Son 60 günün izleyici tutma eğrilerindeki düşüşlerin payı. Bu bulgular senaryo kurallarına işlendi.</div>
    </div>}
    {(g.watch||[]).length>0 && <div style={S.card}>
      <div style={S.cardTitle}>Ne izleniyor (rakipler, haftalık)</div>
      {g.watch.map((w,i)=><div key={i} style={{padding:"8px 0",borderTop:i?`1px solid ${C.line}`:"none",fontSize:14}}>
        <div style={{fontWeight:700}} className="wrap">{w.niche_channels.join(", ")}</div>
        {w.winning.length>0 && <div className="wrap">✅ İzlenen: {w.winning.join(", ")}</div>}
        {w.losing.length>0 && <div className="wrap">⛔ İzlenmeyen: {w.losing.join(", ")}</div>}
        {w.rules.map((r,j)=><div key={j} className="wrap" style={S.small}>• {r}</div>)}
        <div style={S.tiny}>Güncelleme: {w.generated}</div>
      </div>)}
    </div>}
    {(g.channels||[]).map(c=>{ const x=H[c.id]; const v=c.views.map(p=>p.v); const f=c.views.map(p=>p.final);
      const sv=(c.subs||[]).map(p=>p.subs);
      return <div key={c.id} style={S.card}>
        <div style={{display:"flex",justifyContent:"space-between",gap:8}}><b className="wrap" style={{fontSize:16}}>{c.name}</b>
          {x && <span style={{fontSize:14}}>{fmtNum(x.subs)} abone</span>}</div>
        <div style={{...S.small,margin:"6px 0 4px"}}>Günlük izlenme{x?` · 28 günde ${fmtNum(x.views_28)} (${x.change})`:""}</div>
        <Spark values={v} finals={f}/>
        {sv.some(s=>s!=null) && <><div style={{...S.small,margin:"8px 0 4px"}}>Abone sayısı</div><Spark values={sv} color={C.yellow} h={28}/></>}
        {x && <MoneyBars m={x.money}/>}
      </div>; })}
    {gr && <Hourly channels={(gr.channels||[]).filter(c=>c.active)}/>}
  </div>;
}

// ─── SISTEM SEKMESI (teknik ayrinti burada) ───────────────────────────────
function QcCard() {
  const [q] = useJSON("/api/v3/qc");
  if(!q) return null;
  return <div style={S.card}>
    <div style={S.cardTitle}>🛡 Kalite kapısı</div>
    {q.today && <div style={{fontSize:14,marginBottom:6}}>Bugün: geçen <b style={{color:C.green}}>{q.today.passed}</b> · reddedilen <b style={{color:C.yellow}}>{q.today.rejected}</b></div>}
    {(q.checks||[]).length>0 && <div style={{...S.small,marginBottom:6}}>Son 7 gün en çok red sebebi: {q.checks.map(c=>`${c.label} (${c.n})`).join(", ")}</div>}
    {(q.recent||[]).length>0 && <Collapse title={`Son reddedilenler (${q.recent.length})`}>
      {q.recent.map((r,i)=><div key={i} className="wrap" style={{...S.tiny,padding:"4px 0",borderTop:`1px solid ${C.line}`}}>
        {r.at} · {r.channel} · “{String(r.title).slice(0,60)}” — {r.why}</div>)}</Collapse>}
  </div>;
}

function TechDetails() {
  const [d] = useJSON("/api/v3/home");
  if(!d) return null;
  const pr = (d.problems||[]).filter(p=>p.tech), ch = (d.channels||[]).filter(c=>c.tech);
  if(!pr.length && !ch.length) return null;
  return <div style={S.card}><Collapse title="🔧 Sorun ve kanal satırlarının teknik ayrıntısı">
    {pr.map((p,i)=><div key={"p"+i} className="wrap" style={{...S.tiny,padding:"4px 0",borderTop:`1px solid ${C.line}`}}><b>{p.what}</b><br/>{p.tech}</div>)}
    {ch.map(c=><div key={c.id} className="wrap" style={{...S.tiny,padding:"4px 0",borderTop:`1px solid ${C.line}`}}><b>{c.name}</b> ({c.id}): {c.tech}</div>)}
  </Collapse></div>;
}

function System({onNotify, onLogout}) {
  const [dash] = useJSON("/api/v4/dash");
  const [h] = useJSON("/api/health/summary");
  const [live] = useJSON("/api/dashboard/live");
  const [sys] = useJSON("/api/v2/system");
  const [today] = useJSON("/api/v2/today");
  const [social] = useJSON("/api/social/status");
  const [chStatus] = useJSON("/api/channels/status");
  return (
    <div>
      <Header title="Sistem" sub="Teknik ayrıntılar"/>
      <style>{GRID_CSS}</style>
      {dash && <DashSections d={dash} keys={["sistem","kalite","uyari"]} onGo={()=>{}} onGoal={()=>{}}/>}
      <Health h={h} live={live} sys={sys}/>
      <QcCard/>
      <PackageWatch pw={today?.package_watch}/>
      <AiBudgetCard b={today?.ai_budget}/>
      <FocusCard fx={today?.focus}/>
      <StockCard st={today?.stock}/>
      <QuotaLedger h={h}/>
      {today?.ai && (today.ai.rows||[]).length>0 && <div style={S.card}><Collapse title="🤖 Yapay zekâ bütçesi (bugün, 03:00'te sıfırlanır)"><AiTable ai={today.ai}/></Collapse></div>}
      <DiskQueue/>
      <TechDetails/>
      <Accounts social={social} chStatus={chStatus} onNotify={onNotify}/>
      {(h?.notify_suppressed||[]).length>0 && <div style={S.card}>
        <Collapse title={`📭 Telegram'a gönderilmeyen bilgi mesajları (${h.notify_suppressed.length})`}>
          {h.notify_suppressed.map((m,i)=><div key={i} className="wrap" style={{...S.tiny,padding:"4px 0",borderTop:`1px solid ${C.line}`}}>
            {trTime(m.at)} · {m.src}: {String(m.text).slice(0,200)}</div>)}
        </Collapse></div>}
      <div style={S.card}>
        <div style={S.cardTitle}>🧰 Araçlar</div>
        <Collapse title="🎬 Elle yükleme / üretim"><Produce onNotify={onNotify}/></Collapse>
        <Collapse title="➕ Yeni kanal oluştur"><NewChannel onNotify={onNotify}/></Collapse>
        <Collapse title="🔄 Analitiği şimdi yenile"><RefreshAnalytics onNotify={onNotify}/></Collapse>
        <Collapse title="📋 Sistem logları"><Logs/></Collapse>
        <Collapse title="🤖 AI asistan"><AIChat/></Collapse>
        <Collapse title="🧠 Brain (öğrenilen konular)"><Brain/></Collapse>
      </div>
      <div style={S.card}>
        <div style={S.cardTitle}>🔐 Oturum</div>
        <div style={{...S.small,marginBottom:8}}>Parolayı değiştirmek için sunucuda: <code>python3 /opt/creatoros/panel_auth.py --set-password</code> (yeni parola credentials/panel_password.txt'ye yazılır, tüm oturumlar kapanır).</div>
        <button onClick={onLogout} style={ghost({width:"100%"})}>Çıkış yap</button>
      </div>
    </div>
  );
}

// ─── PLATFORMLAR SEKMESI (GOREV379) ───────────────────────────────────────
function fmtPl(n) { return (n===null||n===undefined) ? "—" : Number(n).toLocaleString("tr-TR"); }
function PctBadge({p}) {
  if(p===null||p===undefined) return <span style={{color:C.dim,fontSize:12}}>önceki dönem yok</span>;
  return <span style={{color:p>=0?"#4ade80":"#f87171",fontSize:12,fontWeight:700}}>{p>=0?"▲":"▼"} %{Math.abs(p)}</span>;
}
function Strip({vals}) {
  if(!vals||!vals.length) return null;
  const mx = Math.max(...vals,1);
  return <div style={{display:"flex",alignItems:"flex-end",gap:3,height:34,marginTop:6}}>{vals.map((v,i)=><div key={i} title={String(v)} style={{flex:1,minWidth:0,height:Math.max(2,Math.round(34*v/mx)),background:C.accent,borderRadius:2,opacity:0.85}}/>)}</div>;
}
function VidList({title,rows,emptyText}) {
  return <div style={{marginTop:10}}>
    <div style={{...S.small,fontWeight:700,marginBottom:4}}>{title}</div>
    {(!rows||!rows.length) ? <div style={S.small}>{emptyText}</div> : rows.map((r,i)=><div key={i} className="wrap" style={{display:"flex",flexWrap:"wrap",gap:6,padding:"5px 0",borderTop:`1px solid ${C.line}`,fontSize:13,minWidth:0}}>
      <div style={{flex:"1 1 160px",minWidth:0,overflowWrap:"anywhere"}}>{r.link ? <a href={r.link} target="_blank" rel="noreferrer" style={{color:C.text}}>{r.title||"(başlıksız)"}</a> : (r.title||"(başlıksız)")}{r.account?<span style={{color:C.dim}}> · @{r.account}</span>:null}</div>
      <div style={{color:C.dim,whiteSpace:"nowrap"}}>{fmtPl(r.views)} izl.{r.ratio?` · ${r.ratio}×`:""}{r.date?` · ${r.date}`:""}</div>
    </div>)}
  </div>;
}
function PlatformBox({icon,name,d}) {
  if(!d) return <div style={S.card}><b>{icon} {name}</b><Loading/></div>;
  const bad = d.error && d.followers===undefined && !(d.top&&d.top.length);
  return <div style={{...S.card,minWidth:0}}>
    <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:6,minWidth:0}}><b style={{fontSize:16}}>{icon} {name}</b>
      <span style={{...S.small}}>son güncelleme: {d.updated ? d.updated.replace("T"," ").slice(0,16)+" UTC" : "—"}</span></div>
    {bad ? <div style={{color:"#f87171",fontSize:14,padding:"10px 0",overflowWrap:"anywhere"}}>{d.error}</div> : <>
      <div style={{display:"flex",flexWrap:"wrap",gap:14,marginTop:10,minWidth:0}}>
        <div style={{flex:"1 1 120px",minWidth:0}}><div style={S.small}>{d.followers_label||"takipçi"}</div><div style={{fontSize:24,fontWeight:800}}>{fmtPl(d.followers)}</div></div>
        <div style={{flex:"1 1 120px",minWidth:0}}><div style={S.small}>son 7 gün izlenme</div><div style={{fontSize:24,fontWeight:800}}>{fmtPl(d.views7)}</div><PctBadge p={d.pct7}/></div>
        <div style={{flex:"1 1 120px",minWidth:0}}><div style={S.small}>son 28 gün izlenme</div><div style={{fontSize:24,fontWeight:800}}>{fmtPl(d.views28)}</div><PctBadge p={d.pct28}/></div>
      </div>
      {d.error && <div style={{color:"#fbbf24",fontSize:12,marginTop:6,overflowWrap:"anywhere"}}>{d.error}</div>}
      {d.note && <div style={{...S.small,marginTop:4}}>{d.note}</div>}
      {d.median!==undefined && <div style={{...S.small,marginTop:6}}>hesap medyanı: {fmtPl(d.median)} izlenme · son 10 video:</div>}
      {d.last10 && <Strip vals={d.last10}/>}
      {d.accounts && Object.keys(d.accounts).map(k=>{ const a=d.accounts[k]; return <div key={k} style={{marginTop:8,padding:"6px 0",borderTop:`1px solid ${C.line}`,fontSize:13,overflowWrap:"anywhere"}}>
        <b>@{a.handle}</b> {a.no_data ? <span style={{color:C.dim}}>— {a.no_data}</span> : a.error&&!a.followers ? <span style={{color:"#f87171"}}>— {a.error}</span> : <span style={{color:C.dim}}>· {fmtPl(a.followers)} takipçi · medyan {fmtPl(a.median)} · ölçüt: {a.metric}</span>}
        {a.last10 && <Strip vals={a.last10}/>}</div>; })}
      <VidList title="En çok izlenen 5 (son 28 gün)" rows={d.top} emptyText="Bu dönemde veri yok."/>
      <VidList title="Öne çıkanlar (hesap medyanının ≥3 katı)" rows={d.highlights} emptyText="Şu an medyanın 3 katını aşan yok."/>
    </>}
  </div>;
}
function Platforms() {
  const [d,,reload] = useJSON("/api/v3/platforms",{refresh:300000});
  return <div>
    <Header title="Platformlar" sub="YouTube, TikTok ve Instagram tek bakışta" right={<button onClick={reload} style={ghost()}>↻</button>}/>
    <PlatformBox icon="▶️" name="YouTube (12 kanal)" d={d&&d.youtube}/>
    <PlatformBox icon="🎵" name="TikTok" d={d&&d.tiktok}/>
    <PlatformBox icon="📸" name="Instagram (3 hesap)" d={d&&d.instagram}/>
  </div>;
}

// ─── ANA UYGULAMA ─────────────────────────────────────────────────────────
const TABS = [
  {id:"home",label:"Ana Sayfa",icon:"🏠"},
  {id:"today",label:"Özet",icon:"📋"},
  {id:"channels",label:"Kanallar",icon:"📺"},
  {id:"growth",label:"Büyüme",icon:"📈"},
  {id:"platforms",label:"Platformlar",icon:"📱"},
  {id:"system",label:"Sistem",icon:"⚙️"},
];

export default function App() {
  const [auth,setAuth] = useState(null);   // null: kontrol ediliyor, false: giriş gerekli, true: girişli
  const [gen,setGen] = useState(0);
  const [tab,setTab] = useState("home");
  const [visited,setVisited] = useState({home:true});
  const [note,setNote] = useState({msg:"",type:""});
  const onNotify = useCallback((msg,type="success")=>{ setNote({msg,type}); setTimeout(()=>setNote({msg:"",type:""}),3500); },[]);
  useEffect(()=>{
    fetch(API+"/api/auth/me",{credentials:"same-origin"}).then(r=>setAuth(r.ok)).catch(()=>setAuth(false));
    const h = ()=>setAuth(false);
    window.addEventListener("cos-login", h);
    return ()=>window.removeEventListener("cos-login", h);
  },[]);
  function go(id) { setTab(id); setVisited(v=>({...v,[id]:true})); window.scrollTo(0,0); }
  async function logout() { await fetch(API+"/api/auth/logout",{method:"POST",credentials:"same-origin"}).catch(()=>{}); setAuth(false); }
  const shell = children => <div style={{minHeight:"100vh",background:C.bg,color:C.text,overflowX:"hidden"}}><style>{GLOBAL_CSS}</style>{children}</div>;
  if(auth===null) return shell(<Loading text="Yükleniyor..."/>);
  if(!auth) return shell(<Login onDone={()=>{ setGen(g=>g+1); setVisited({home:true}); setTab("home"); setAuth(true); }}/>);
  const pages = { home:<HomeDash onNotify={onNotify} onGo={t=>go({ozet:"today",kanallar:"channels",buyume:"growth",sistem:"system"}[t]||"home")}/>, today:<Today onNotify={onNotify}/>, channels:<Channels onNotify={onNotify}/>, growth:<Growth/>, platforms:<Platforms/>,
    system:<System onNotify={onNotify} onLogout={logout}/> };
  return (
    <div key={gen} style={{minHeight:"100vh",background:C.bg,color:C.text,paddingBottom:"calc(76px + env(safe-area-inset-bottom))",overflowX:"hidden"}}>
      <style>{GLOBAL_CSS}</style>
      <Notify msg={note.msg} type={note.type} onClose={()=>setNote({msg:"",type:""})}/>
      <main style={{maxWidth:980,margin:"0 auto",padding:"14px 16px 0",width:"100%"}}>
        {TABS.map(t=> visited[t.id] ? <div key={t.id} style={{display:tab===t.id?"block":"none"}}>{pages[t.id]}</div> : null)}
      </main>
      <nav style={{position:"fixed",bottom:0,left:0,right:0,background:"rgba(10,10,15,0.96)",backdropFilter:"blur(20px)",WebkitBackdropFilter:"blur(20px)",
        borderTop:`1px solid ${C.line}`,paddingBottom:"env(safe-area-inset-bottom)",zIndex:100}}>
        <div style={{display:"flex",maxWidth:980,margin:"0 auto"}}>
          {TABS.map(t=>(
            <button key={t.id} onClick={()=>go(t.id)} style={{flex:1,minWidth:0,minHeight:60,background:"none",border:"none",cursor:"pointer",
              color:tab===t.id?C.accent:"rgba(255,255,255,0.5)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:2,
              fontSize:12,fontWeight:tab===t.id?700:500}}>
              <span style={{fontSize:20}}>{t.icon}</span>{t.label}
            </button>))}
        </div>
      </nav>
    </div>
  );
}
